<template>
  <div v-show="isShow" class="bueatyScrollDiv">
    <el-divider content-position="center" style="font-size: 20px">{{ json.name }}</el-divider>
    <el-table
        id="table"
        class="bueatyScroll"
        ref="maintb"
        :key="tableKey"
        v-loading="loading"
        v-if="json.isManyHeader == true"
        element-loading-text="Loading..."
        :data="json.data"
        :cell-style="warningCellStyle"
        :header-cell-style="warningHeaderStyle"
        border
        stripe
        fit
        :default-sort="{ prop: 'id', order: 'descending' }"
        highlight-current-row
        width="100%"
        :height="tableHeightNum"
        @span-method="objectSpanMethod"
        @cell-dblclick="tableClick"
        @cell-contextmenu="openMenu"
        @contextmenu.prevent
        @selection-change="handleSelectionChange"
        @header-dragend="dragendHeader"
        :row-style="rowStyle"
    >
      <el-table-column label="序号" header-align="center" align="center" :fixed="true" width="60px" :sortable="false" show-overflow-tooltip>
        <template #default="scope">
          <div>
            {{scope.$index+1+(ViewCurrentPage-1)*ViewpageSize}}
          </div>
        </template>
      </el-table-column>
      <el-table-column type="selection" width="55" :selectable="checkSelectable" v-if="selectable"/>
      <el-table-column
          v-for="ite in json.manyHeader"
          :prop="ite.id"
          :label="ite.name"
          :key="ite.id">
        <el-table-column
            v-for="(item,index) in ite.children"
            :key="index"
            :prop="item.data"
            :fixed="item.isFixed"
            :label="item.label"
            :width="getHeadWidth(item)"
            sortable
            :sort-method="(a,b)=>sort(a,b,item.data)"
            align="center"
            header-align="center"
            show-overflow-tooltip>
          <template #header="scope">
            <!--@click.stop="tableFixed(item.label,scope.column,scope.$index)"-->
            <icon
                :ref="'icons'+`${scope.$index}`"
                :class="{'color':scope.$index<json.xxoo,'el-icon-lock':scope.$index<json.xxoo,'el-icon-unlock':scope.$index>xxoo}"></icon>
            <!--:class="{'el-icon-lock':true,'color':xxxx<=$index}"-->
            {{ "unitLabel" in item ? item.unitLabel : item.label }}
          </template>
          <template #default="scope">
            <div>
              <el-input
                  v-if="showxx(scope,'edit')"
                  ref="input"
                  autofocus
                  v-model="scope.row[scope.column.property].value"
                  @blur="changeData(scope)"
              ></el-input>
              <div v-else-if="typeof(scope.row[scope.column.property]['value'])=='object'">
              <span
                  v-if="scope.row[scope.column.property].value==null">
                  {{ scope.row[scope.column.property].value }}</span>
                <span
                    v-if="scope.row[scope.column.property].value==undefined">
                  {{ scope.row[scope.column.property].value }}</span>
                <el-image class="imageShow"
                          v-else-if="scope.row[scope.column.property].value.type=='image'"
                          style="width: 80px; height: 60px"
                          :src="scope.row[scope.column.property].value.name"
                >
                </el-image>
                <el-button
                    @click.stop="showWebViewer(scope.row[scope.column.property].value.link,scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='webRoute'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <el-button
                    @click.stop="showRouteImage(scope.row[scope.column.property].value.link,scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='imageRoute'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <el-button
                    @click.stop="showGmpImage(scope.row[scope.column.property].value.link,scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='gmpRoute'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <!--              <a v-else-if="scope.row[scope.column.property].value.type=='downloadfile'" :href="scope.row[scope.column.property].value.link" download="test.rar">{{ scope.row[scope.column.property].value.name }}</a>-->
                <el-button
                    @click.stop="fileDownload(scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='downloadfile'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <el-button
                    @click.stop="showTxt(scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='word'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <el-button
                    @click.stop="showTxt(scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='excel'"
                    type="text"
                    size="mini"
                >{{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <el-button
                    v-else-if="scope.row[scope.column.property]['value'].router!=undefined"
                    size="mini"
                    type="text"
                    @click.stop="openDetail(scope,item)"
                >{{ scope.row[scope.column.property].value["name"] }}
                </el-button>
                <span v-else>{{ scope.row[scope.column.property].value.name }}</span>
              </div>
              <div v-else-if="typeof(scope.row[scope.column.property])=='object'">
              <span
                  v-if="scope.row[scope.column.property]==null">
                  {{ scope.row[scope.column.property].value }}</span>
                <span
                    v-if="scope.row[scope.column.property]==undefined">
                  {{scope.row[scope.column.property].value }}</span>
                <el-button
                    v-else-if="item.router!=undefined"
                    size="mini"
                    type="text"
                    @click.stop="openDetail(scope,item)"
                >{{ scope.row[scope.column.property].value }}
                </el-button>
                <el-image
                    v-else-if="scope.row[scope.column.property].value.type=='image'"
                    lazy
                    :preview-src-list="urlList"
                    style="width: 50px; height: 50px"
                    :src="url"
                >
                </el-image>
                <el-button
                    @click.stop="showRouteImage(scope.row[scope.column.property].value.link,scope)"
                    v-else-if="scope.row[scope.column.property].type=='imageRoute'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value }}
                </el-button>
                <el-button
                    @click.stop="showGmpImage(scope.row[scope.column.property].value.link,scope)"
                    v-else-if="scope.row[scope.column.property].type=='gmpRoute'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value }}
                </el-button>
                <!--              <a v-else-if="scope.row[scope.column.property].value.type=='downloadfile'" :href="scope.row[scope.column.property].value.link" download="test.rar">{{ scope.row[scope.column.property].value.name }}</a>-->
                <el-button
                    @click.stop="fileDownload(scope)"
                    v-else-if="scope.row[scope.column.property].type=='downloadfile'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value}}
                </el-button>
                <el-button
                    @click.stop="showTxt(scope)"
                    v-else-if="scope.row[scope.column.property].type=='word'"
                    type="text"
                    size="mini">
                  {{ scope.row[scope.column.property].value }}
                </el-button>
                <el-button
                    @click.stop="showTxt(scope)"
                    v-else-if="scope.row[scope.column.property].value.type=='excel'"
                    type="text"
                    size="mini"
                >{{scope.row[scope.column.property].value }}
                </el-button>
                <span v-else>{{ scope.row[scope.column.property].value }}</span>
                <!--              <span>{{ scope.row[scope.column.property].value }}</span>-->
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
          v-if="json.operation"
          fixed="right"
          label="操作"
          width="120"
          align="center"
          header-align="center">
        <template #default="scope">
          <!--<el-button :disabled="scope.row.stateCode.value==1?true:false" type="text" size="mini" @click.prevent="ChangeRow(scope)">Edit</el-button>-->
          <el-button
              type="text"
              size="mini"
              @click.prevent="deleteRow(scope)">移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table
        id="table"
        class="bueatyScroll"
        ref="maintb"
        :key="tableKey"
        v-loading="loading"
        v-else
        element-loading-text="Loading..."
        :data="json.data"
        :cell-style="warningCellStyle"
        :header-cell-style="warningHeaderStyle"
        border
        stripe
        fit
        :default-sort="{ prop: 'id', order: 'descending' }"
        highlight-current-row
        width="100%"
        :height="tableHeightNum"
        @span-method="objectSpanMethod"
        @row-dblclick="handleRowDbClick"
        @cell-dblclick="tableClick"
        @cell-contextmenu="openMenu"
        @contextmenu.prevent
        @selection-change="handleSelectionChange"
        @header-dragend="dragendHeader"
        :row-style="rowStyle"
    >
      <el-table-column label="序号" header-align="center" align="center" :fixed="true" width="60px" :sortable="false" show-overflow-tooltip>
        <template #default="scope">
          <div>
            {{scope.$index+1+(ViewCurrentPage-1)*ViewpageSize}}
          </div>
        </template>
      </el-table-column>
      <el-table-column type="selection" width="55" :selectable="checkSelectable" v-if="selectable"/>
      <el-table-column
          v-for="(item,index) in json.header"
          :key="index"
          :prop="item.data"
          :fixed="item.isFixed"
          :label="item.label"
          :width="getHeadWidth(item)"
          sortable
          :sort-method="(a,b)=>sort(a,b,item.data)"
          align="center"
          header-align="center"
          :filters="getHeadFilter(item)"
          :filter-method="item.TABLE_NAME=='TLM_BANK_WELL_DEVI_INTER_V' && (item.label=='测斜方式'||item.label=='阶段')?filterHandler:null"
          show-overflow-tooltip>
        <template #header="scope">
          <!--@click.stop="tableFixed(item.label,scope.column,scope.$index)"-->
          <icon
              :ref="'icons'+`${scope.$index}`"
              :class="{'color':scope.$index<json.xxoo,'el-icon-lock':scope.$index<json.xxoo,'el-icon-unlock':scope.$index>xxoo}"></icon>
          <!--:class="{'el-icon-lock':true,'color':xxxx<=$index}"-->
          {{ "unitLabel" in item ? item.unitLabel : item.label }}
        </template>
        <template #default="scope">
          <div>
            <el-input
                v-if="showxx(scope,'edit')"
                ref="input"
                autofocus
                v-model="scope.row[scope.column.property].value"
                @blur="changeData(scope)"
            ></el-input>
            <div v-else-if="typeof(scope.row[scope.column.property]['value'])=='object'">
              <span
                  v-if="scope.row[scope.column.property].value==null">
                  {{ scope.row[scope.column.property].value }}</span>
              <span
                  v-if="scope.row[scope.column.property].value==undefined">
                  {{ scope.row[scope.column.property].value }}</span>
              <el-image class="imageShow"
                  v-else-if="scope.row[scope.column.property].value.type=='image'"
                  style="width: 80px; height: 60px"
                  :src="scope.row[scope.column.property].value.name"
              >
              </el-image>
              <div v-else-if="scope.row[scope.column.property].value.type=='image64'" @click="onPreViewImg64(scope.row[scope.column.property].value)" style="text-align: center">
                <el-image :src="'data:image/png;base64,'+scope.row[scope.column.property].value.name" style="width: 80px">
                </el-image>
              </div>
              <el-button
                  @click.stop="showWebViewer(scope.row[scope.column.property].value.link,scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='webRoute'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <el-button
                  @click.stop="showRouteImage(scope.row[scope.column.property].value.link,scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='imageRoute'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <el-button
                  @click.stop="showGmpImage(scope.row[scope.column.property].value.link,scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='gmpRoute'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <!--              <a v-else-if="scope.row[scope.column.property].value.type=='downloadfile'" :href="scope.row[scope.column.property].value.link" download="test.rar">{{ scope.row[scope.column.property].value.name }}</a>-->
              <el-button
                  @click.stop="fileDownload(scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='downloadfile'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <el-button
                  @click.stop="showTxt(scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='word'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <el-button
                  @click.stop="showTxt(scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='excel'"
                  type="text"
                  size="mini"
              >{{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <el-button
                  v-else-if="scope.row[scope.column.property]['value'].router!=undefined"
                  size="mini"
                  type="text"
                  @click.stop="openDetail(scope,item)"
              >{{ scope.row[scope.column.property].value["name"] }}
              </el-button>
              <span v-else>{{ scope.row[scope.column.property].value.name }}</span>
            </div>
            <div v-else-if="typeof(scope.row[scope.column.property])=='object'">
              <span
                  v-if="scope.row[scope.column.property]==null">
                  {{ scope.row[scope.column.property].value }}</span>
              <span
                  v-if="scope.row[scope.column.property]==undefined">
                  {{scope.row[scope.column.property].value }}</span>
              <el-button
                  v-else-if="item.router!=undefined"
                  size="mini"
                  type="text"
                  @click.stop="openDetail(scope,item)"
              >{{ scope.row[scope.column.property].value }}
              </el-button>
              <el-image
                  v-else-if="scope.row[scope.column.property].value.type=='image'"
                  lazy
                  :preview-src-list="urlList"
                  style="width: 50px; height: 50px"
                  :src="url"
              >
              </el-image>
              <div v-else-if="scope.row[scope.column.property].value.type=='image64'" @click="onPreViewImg64(scope.row[scope.column.property].value)" style="text-align: center">
                <el-image :src="'data:image/png;base64,'+scope.row[scope.column.property].value.name" style="width: 80px">
                </el-image>
              </div>
              <el-button
                  @click.stop="showRouteImage(scope.row[scope.column.property].value.link,scope)"
                  v-else-if="scope.row[scope.column.property].type=='imageRoute'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value }}
              </el-button>
              <el-button
                  @click.stop="showGmpImage(scope.row[scope.column.property].value.link,scope)"
                  v-else-if="scope.row[scope.column.property].type=='gmpRoute'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value }}
              </el-button>
              <!--              <a v-else-if="scope.row[scope.column.property].value.type=='downloadfile'" :href="scope.row[scope.column.property].value.link" download="test.rar">{{ scope.row[scope.column.property].value.name }}</a>-->
              <el-button
                  @click.stop="fileDownload(scope)"
                  v-else-if="scope.row[scope.column.property].type=='downloadfile'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value}}
              </el-button>
              <el-button
                  @click.stop="showTxt(scope)"
                  v-else-if="scope.row[scope.column.property].type=='word'"
                  type="text"
                  size="mini">
                {{ scope.row[scope.column.property].value }}
              </el-button>
              <el-button
                  @click.stop="showTxt(scope)"
                  v-else-if="scope.row[scope.column.property].value.type=='excel'"
                  type="text"
                  size="mini"
              >{{scope.row[scope.column.property].value }}
              </el-button>
              <span v-else>{{ scope.row[scope.column.property].value }}</span>
              <!--              <span>{{ scope.row[scope.column.property].value }}</span>-->
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          v-if="json.operation"
          fixed="right"
          label="操作"
          width="120"
          align="center"
          header-align="center">
        <template #default="scope">
          <!--<el-button :disabled="scope.row.stateCode.value==1?true:false" type="text" size="mini" @click.prevent="ChangeRow(scope)">Edit</el-button>-->
          <el-button
              type="text"
              size="mini"
              @click.prevent="deleteRow(scope)">移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-image-viewer v-if="showImg64PreViewer"
                     @close="closePreViewImg64"
                     z-index="9999"
                     :hide-on-click-modal="true"
                     :url-list = "[img64PreviewUrl]"/>
    <div v-dialogDrag>
      <el-dialog v-model="problemDialogVisible" title="反馈信息" width="500px">
        <el-form :model="changes">
          <el-form-item label="关键信息">
            <el-input type="text" disabled
                      :modelValue="curProblemData.keyInfo"></el-input>
          </el-form-item>
          <el-form-item label="问题数据">
            <el-input type="text" disabled :modelValue="curProblemData.columnName"></el-input>
          </el-form-item>
          <el-form-item label="当前数值">
            <el-input type="text" disabled :modelValue="curProblemData.cellVal"></el-input>
          </el-form-item>
          <el-form-item label="期望数值">
            <el-input type="text" v-model="curProblemData.hopeVal"></el-input>
          </el-form-item>
          <el-form-item label="反馈原因">
            <el-input type="textarea" :rows="3" v-model="curProblemData.remark"></el-input>
          </el-form-item>
          <el-form-item label="附件上传">
            <el-upload
                ref="upload"
                class="upload-demo"
                :auto-upload="false"
                :limit="1"
                :on-exceed="problemFileExceed"
                @change="problemFileChange"
            >
              <!--            <template #trigger>-->
              <el-button size="small" type="primary">选择文件</el-button>
              <!--            </template>-->
              <!--            <el-button-->
              <!--                style="margin-left: 10px"-->
              <!--                size="small"-->
              <!--                type="success"-->
              <!--                @click="submitUpload"-->
              <!--            >开始上传</el-button-->
              <!--            >-->
              <!--            <template #tip>-->
              <!--              <div class="el-upload__tip">-->
              <!--                问题相关证明材料-->
              <!--              </div>-->
              <!--            </template>-->
            </el-upload>
          </el-form-item>
        </el-form>
        <template #footer>
        <span class="dialog-footer">
            <el-button @click="$refs.upload.clearFiles();problemDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="doDataProblemRecord">确定</el-button>
        </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog v-model="dialogFormVisible" title="编辑">
        <el-form :model="changes">
          <el-form-item label="姓名">
            <el-input type="text" v-model="changes.name.value"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="changeRowOk">确定</el-button>
                </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <dialog-ex
          v-model="fileDialogVisible"
          :title="fileDialogTitle"
          @closeMsg="closeFileDialog"
          width="100%"
          :is-fullscreen="true"
      >
        <template #body>
          <iframe id="iooIfream"
                  onload="this.height=document.body.scrollHeight-64"
                  :src="docShowIframeUrl"
                  width="100%" height="100%" frameborder="0"></iframe>
        </template>
      </dialog-ex>
    </div>
    <div v-dialogDrag>
      <dialog-ex
          v-model="imgDialogVisible"
          :title="imgDialogTitle"
          @closeMsg="closeImgDialog"
      >
        <template #body>
          <el-image :src="routeImgUrl" fit="fill" :preview-src-list="[routeImgUrl]" lazy></el-image>
        </template>
      </dialog-ex>
    </div>
    <div v-dialogDrag>
      <el-dialog @close="fileName=''" v-model="fileExportDialogVisible" title="导出" width="500px">
        <el-form>
          <el-form-item label="请输入文件名">
            <el-input v-model="fileName"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
              <el-button @click="fileExportDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="fileOk">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <el-drawer
        v-model="drawer"
        :show-close="false"
        :destroy-on-close="true"
        direction="btt"
        title="123456"
        lock-scroll
        size="530px"
    >
      <flow-chart v-if="isFlowChartShow" :selected-strict="false" ref="flowChart"></flow-chart>
      <!--    表格     -->
      <div style="padding:0 20px">
        <el-row type="flex" justify="space-between">
          <el-col span="4">
            <el-button size="mini" type="primary" @click.stop="exportTable('drill')" style="margin-bottom: 10px">导出
            </el-button>
          </el-col>
          <el-col span="12">
            <el-pagination
                v-if="drawchart==true"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="drawerPageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="drawerDataNum"
                :page-count="drawerPageCount"
                :current-page="drawerCurrentPage"
                @size-change="tablesizeChange"
                @current-change="currenttableChange"
                style="text-align: right"
            >
            </el-pagination>
          </el-col>
        </el-row>

        <el-table
            v-if="drawchart==true"
            :data="tableData"
            height="427px"
            v-loading="drillLoading"
            border
            id="exportTable"
            highlight-current-row
            :row-style="rowStyle">
          <el-table-column
              v-for="item in tableHeader"
              :key="item"
              :prop="item.data"
              :label="item.label"
              sortable
              align="center"
              header-align="center"
              show-overflow-tooltip>
            <template #default="scope">
              <div v-if="scope.row[scope.column.property] == null?false:typeof(scope.row[scope.column.property])=='object' && scope.row[scope.column.property].type=='image64'" @click="onPreViewImg64(scope.row[scope.column.property])" style="text-align: center">
                <el-image :src="'data:image/png;base64,'+scope.row[scope.column.property].name" style="width: 80px">
                </el-image>
              </div>
              <el-button type="text"
                         v-else-if="scope.row[scope.column.property] == null?false:typeof(scope.row[scope.column.property])=='object'"
                         @click="drawerClick(scope.row[scope.column.property],scope)">
                {{ scope.row[scope.column.property] == null ? '-' : scope.row[scope.column.property].name }}
              </el-button>
              <span v-else>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    曲线    -->
      <div>
        <highchart v-show="viewDisplay" v-loading="drillLoading" ref="highchart" :id="id" :option="option"
                   :chart-type="chartType" style="height: 800px"/>
      </div>
      <template #title>
        <div style="text-align:center">{{ drawerTitle }}</div>
      </template>
    </el-drawer>
<!--    <div v-dialogDrag>-->
<!--      <el-dialog v-model="drawerDialogVisible" title="文件预览" width="80%" height="600px">-->
<!--        <template #default>-->
<!--          <iframe id="iooIfream6"-->
<!--                  :src="drawerLink"-->
<!--                  width="100%" height="100vh" frameborder="0"></iframe>-->
<!--        </template>-->
<!--        <template #footer>-->
<!--          <el-button @click="fileDownload(drawerLink)">下载</el-button>-->
<!--        </template>-->
<!--      </el-dialog>-->
<!--    </div>-->
    <div v-dialogDrag>
      <el-dialog v-model="screeningDialogVisible" title="数据甄别" width="500px" height="600px">
        <el-form>
          <el-form-item label="关键信息">
            <el-input type="text" disabled v-model="primaryKeyText"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-switch v-model="screeningData.use"/>
            <span style="margin-left: 10px">{{ screeningData.use == false ? "否" : "是" }}</span>
          </el-form-item>
          <el-form-item label="反馈原因">
            <el-input type="textarea" :rows="3" v-model="screeningData.remark"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="screeningDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="dataScreenOk">提交</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li  @click="doContextMenu">数据问题记录</li>
<!--      <li  @click="dataScreening">数据甄别</li>-->
    </ul>

    <!--考核指标方案——表格弹窗-->
    <div v-dialogDrag>
      <dialog-ex
          v-model="assessDialogVisible"
          title="考核指标详情"
          width="80%"
          @closeMsg="closeAsseaaDialog"
          :is-footer="true">
        <template #body>
         <index-algorithm-manger-view :template-info="assessTemplateInfo" />
        </template>
      </dialog-ex>
    </div>
    <!--数据上传记录详情——表格弹窗-->
    <div v-dialogDrag>
      <dialog-ex
          v-model="uploadListDialogVisible"
          title="数据上传详情"
          width="60%"
          @closeMsg="closeUploadListDialog"
          :is-footer="true">
        <template #body>
          <el-button size="mini" type="primary" @click.stop="exportTable('upload')" style="margin-bottom: 10px" v-if="uploadLisType!='预测数据'">导出</el-button>
          <el-scrollbar max-height="500px">
            <div v-if="uploadLisType=='预测数据'">
              <div label="拟合数据：">
                <el-table :data="fittingDatas" height="150" stripe border highlight-current-row>
                  <el-table-column label="" prop="name" width="110px"></el-table-column>
                  <el-table-column label="开始时间" prop="start"></el-table-column>
                  <el-table-column label="结束时间" prop="end"></el-table-column>
                  <el-table-column label="递减类型" prop="" width="130px">
                    <template #default="scope">
                      <div style="text-align: center">{{ fittingMap[fittingDatas[scope.$index].type] }}</div>
                      <!--                    <el-select v-model="fittingDatas[scope.$index].type"  placeholder="未选择">-->
                      <!--                      <el-option-->
                      <!--                          v-for="item in fittingtype"-->
                      <!--                          :key="item.data"-->
                      <!--                          :label="item.label"-->
                      <!--                          :value="item.data">-->
                      <!--                      </el-option>-->
                      <!--                    </el-select>-->
                    </template>
                  </el-table-column>
                  <el-table-column label="拟合公式" prop="formula" width="260px">
                    <template #default="scope">
                      <div style="text-align: center">{{ fittingDatas[scope.$index].formular }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="相关系数" prop="r">
                    <template #default="scope">
                      <div style="text-align: center">{{ fittingDatas[scope.$index].r }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="初始产量" prop="Q0">
                    <template #default="scope">
                      <!--                <el-input v-model="fittingDatas[scope.$index].Q0" size="small" />-->
                      <div style="text-align: center">{{ fittingDatas[scope.$index].Q0 }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="递减率" prop="a">
                    <template #default="scope">
                      <!--                <el-input v-model="fittingDatas[scope.$index].a" size="small" />-->
                      <div style="text-align: center">{{ fittingDatas[scope.$index].a }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div label="预测数据：">
                <el-table :data="uploadListTableData" border stripe>
                  <el-table-column
                      v-for="item in uploadListHeader"
                      :prop="item.id"
                      :label="item.name"
                      :key="item.id">
                    <template #default="scope">
                      <span>{{ scope.row[scope.column.property] }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-else-if="uploadLisType=='文件导入数据'  || uploadLisType == '录入数据'">
              <el-table :data="uploadListTableData" border stripe id="exportTable">
                <el-table-column
                    v-for="item in uploadListHeader"
                    :prop="item.data"
                    :label="item.label"
                    :key="item.data">
                  <template #default="scope">
                    <span>{{ scope.row[scope.column.property] }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else>
              <el-table :data="uploadListTableData" border stripe id="exportTable">
                <el-table-column
                    v-for="item in uploadListHeader"
                    :prop="item.data"
                    :label="item.label"
                    :key="item.data">
                  <template #default="scope">
                    <span v-if="scope.row[scope.column.property].value instanceof Object">{{
                        scope.row[scope.column.property].value.name
                      }}</span>
                    <span v-else>{{ scope.row[scope.column.property].value }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-scrollbar>
        </template>
      </dialog-ex>
    </div>
    <!--    外部网页显示-->
    <div v-dialogDrag style="height: 100%">
    <el-dialog
        v-dialogDrag
        v-model="webViewrDialogVisible"
        name="webviewerDlg"
        width="100%"
        :fullscreen="true"
    >
      <template #title="{ close, titleId, titleClass }">
        <div class="my-header">
          <el-dropdown :id="titleId" :class="titleClass" trigger="click" @command="webViewerDlgCommand">
              <span class="el-dropdown-link" style="font-size: 20px;font-weight: bold">
                {{webViewrDialogTitle}}
                <i class="el-icon-arrow-down"></i>
              </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item  command="openTarget">其它页面打开</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </template>
        <iframe name="webViewerIfrm"
                onload="this.height=document.body.scrollHeight-64"
                :src="webViewrIframeUrl"
                width="100%"></iframe>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import {ElMessageBox, ElMessage} from 'element-plus'
import axios from 'axios';
import XLSX from "xlsx";
import FileSaver from "file-saver";
import DialogEx from "@/components/dialogEx";
import {ref} from "vue";
import highchart from '@/components/Highchart.vue'
import FlowChart from "@/components/flowChart";
import IndexAlgorithmMangerView from "@/views/assessmentViews/IndexAlgorithmMangerView"
import {hex_md5} from "../../public/static/js/md5";
import {_10to62} from "../../public/static/js/util";
import {_exportTable} from "../../public/static/js/util";
// import ChartView from "@/components/ChartView";
//import contextMenu from "@/components/contextmenu.vue"
//import { defineComponent } from "vue";
addEventListener("message", function (e) {
  // let _this = this;
  if (e.data.command === "init") {
    //   console.log(window.frames);
    //   let transData = {
    //     projectId: '',
    //     entityId: "",
    //     fileSourceUrl: "http://gateway.dev.tlmyt.petrochina/fileprocesser/f/doc/1RRY5NppCA6GCcMEeoc2Ca.pptx",
    //     fileFullName: "ttt"
    //   }
    //   console.log("文件展示信息：",transData);
    //   //初始化
    //   window.frames[0].postMessage(
    //       {
    //         command: "initFile",
    //         type: "url",
    //         readOnly: true,
    //         data: transData
    //       },
    //       "*"
    //   )
  }
}, false);

function docShow(docurl, docName) {
  console.log(window.frames);
  // let docurl2 = docurl.replace("\\", "/");
  console.log(docurl,docName)
  let transData = {
    projectId: '',
    entityId: "",
    // fileSourceUrl: docurl,
    fileSourceUrl: encodeURI(encodeURI(docurl)),
    fileFullName: docName
  }
  console.log("文件展示信息：", transData);
  //初始化
  window.frames[0].postMessage(
      {
        command: "initFile",
        type: "url",
        readOnly: true,
        data: transData
      },
      "*"
  )
}

export default {
  name: "table",
  components: {
    IndexAlgorithmMangerView,
    FlowChart,
    // ChartView,
    highchart,
    DialogEx
  },
  mounted() {
    let jwtSession = localStorage.getItem("lyqtJwt");
    if (jwtSession == null) jwtSession = {};
    if (jwtSession.length > 0) {
      this.docShowIframeUrl = "http://www.dev.tlmyt.petrochina/front/rf-ioo/onlineOffice/index?jwt="+jwtSession;
      // this.docShowIframeUrl = "http://onlineoffice.tlm.pcep.cloud/front/rf-ioo/onlineOffice/index?jwt="+jwtSession;
    }
    this.fileDialogVisible = false;
    if(this.templateInfo){
      this.setProblemMenuVisible();
      if(this.templateInfo.pageCnt != undefined && this.templateInfo.pageCnt != null && this.templateInfo.pageCnt>1){
        this.tableHeightNum = "calc(100vh - 67px - 50px - 28px - 48px - 24px - 54px)";
      }
      else{
        this.tableHeightNum = "calc(100vh - 67px - 50px - 28px - 48px - 24px)";
      }
    }
    this.addOnscroll();
  },
  data() {
    return {
      tableHeightNum : "calc(100vh - 67px - 50px - 28px - 48px - 24px)",
      img64PreviewUrl:"",
      showImg64PreViewer:false,
      webViewrDialogVisible:false,
      webViewrDialogTitle:"成果查看",
      webViewrIframeUrl:"",
      ViewCurrentPage:1,
      ViewpageSize:20,
      drawerDataNum:10,
      drawerPageSize: 20,//每页所展示的数量
      drawerPageCount:1,//总页数
      drawerCurrentPage: 1,//当前页数
      drawerData:{},//钻取时点击的数据
      drawerHead:{},//钻取时点击的表头
      needReCalColWidth:false,
      isFlowChartShow:false,
      loading:true,
      tableKey:0,//报表key值
      drillLoading:true,
      docShowIframeUrl:"http://usercenter.tlm.pcep.cloud/front/rf-ioo/onlineOffice/index?jwt=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbl9uYW1lIjoiN2NmZjZhMWUtMTI3MC00YWIwLWE4YzYtZjkwMmI5NDkxZmI3IiwidXNlcl9pZCI6IjdjZmY2YTFlLTEyNzAtNGFiMC1hOGM2LWY5MDJiOTQ5MWZiNyIsInNjb3BlIjpbIm9wZW5pZCJdLCJvcmdhbml6YXRpb24iOm51bGwsImlzcyI6ImEzNmMzMDQ5YjM2MjQ5YTNjOWY4ODkxY2IxMjcyNDNjIiwiZXhwIjoxNjM4Njk1ODQwLCJkaXNwbGF5X25hbWUiOm51bGwsInJlZ2lvbiI6IlRMIiwiaWF0IjoxNjM2MTAzODQwODAzLCJhdXRob3JpdGllcyI6WyJjb20uY25wYy5lcGFpLm9hdXRoMnNlcnZlci5jb250cm9sbGVyLkNsaWVudENvbnRyb2xsZXIkJExhbWJkYSQ0NC8weDAwMDAwMDAwNjQwNzNjYzBANDQxZjI0ZTYiXSwianRpIjoiZThmN2VkNGYtZWExOS00MGFjLTg3MzktZjE1NDYzNDQ4OWYyIiwiY2xpZW50X2lkIjoiN2NmZjZhMWUtMTI3MC00YWIwLWE4YzYtZjkwMmI5NDkxZmI3In0.UQ2iWtWH_n8Agvh6MAObwf-uoQX2JVXyTgTbVbS3vA9_50SDAkcIERDX4R5FUT9iReHvb4YU2Wvd-quk09m0QdwLDpW6lDPZwNga0cVQ-hpgtEkZA2ftw0kVU1Km-5oCIlHVhOiOOqkJI5u3I3iNafDiBQRTrE90t9Bu4fKTJRhPW6xSi0KvMClplxFQo7sF4VttRv0K6V5Y2wDYlbuMRE1KiAzN79_H_fHbI5wf1jfgNfuhcWh1zuNR-ztOxYGfTfIhochn2GKFKVCbv5eM_G2hTYf9YuGw8bjzTk0R4yTqPxDP-fz6SHfZYwEsWbnfZOK0IWcX-nd_iATswAsamw",
      //docShowIframeUrl:"http://www.dev.tlmyt.petrochina/front/rf-ioo/onlineOffice/index?jwt=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbl9uYW1lIjoiN2NmZjZhMWUtMTI3MC00YWIwLWE4YzYtZjkwMmI5NDkxZmI3IiwidXNlcl9pZCI6IjdjZmY2YTFlLTEyNzAtNGFiMC1hOGM2LWY5MDJiOTQ5MWZiNyIsInNjb3BlIjpbIm9wZW5pZCJdLCJvcmdhbml6YXRpb24iOm51bGwsImlzcyI6ImEzNmMzMDQ5YjM2MjQ5YTNjOWY4ODkxY2IxMjcyNDNjIiwiZXhwIjoxNjM4Njk1ODQwLCJkaXNwbGF5X25hbWUiOm51bGwsInJlZ2lvbiI6IlRMIiwiaWF0IjoxNjM2MTAzODQwODAzLCJhdXRob3JpdGllcyI6WyJjb20uY25wYy5lcGFpLm9hdXRoMnNlcnZlci5jb250cm9sbGVyLkNsaWVudENvbnRyb2xsZXIkJExhbWJkYSQ0NC8weDAwMDAwMDAwNjQwNzNjYzBANDQxZjI0ZTYiXSwianRpIjoiZThmN2VkNGYtZWExOS00MGFjLTg3MzktZjE1NDYzNDQ4OWYyIiwiY2xpZW50X2lkIjoiN2NmZjZhMWUtMTI3MC00YWIwLWE4YzYtZjkwMmI5NDkxZmI3In0.UQ2iWtWH_n8Agvh6MAObwf-uoQX2JVXyTgTbVbS3vA9_50SDAkcIERDX4R5FUT9iReHvb4YU2Wvd-quk09m0QdwLDpW6lDPZwNga0cVQ-hpgtEkZA2ftw0kVU1Km-5oCIlHVhOiOOqkJI5u3I3iNafDiBQRTrE90t9Bu4fKTJRhPW6xSi0KvMClplxFQo7sF4VttRv0K6V5Y2wDYlbuMRE1KiAzN79_H_fHbI5wf1jfgNfuhcWh1zuNR-ztOxYGfTfIhochn2GKFKVCbv5eM_G2hTYf9YuGw8bjzTk0R4yTqPxDP-fz6SHfZYwEsWbnfZOK0IWcX-nd_iATswAsamw",
      // docShowIframeUrl:"http://onlineoffice.tlm.pcep.cloud/front/rf-ioo/onlineOffice/index?jwt=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbl9uYW1lIjoiN2NmZjZhMWUtMTI3MC00YWIwLWE4YzYtZjkwMmI5NDkxZmI3IiwidXNlcl9pZCI6IjdjZmY2YTFlLTEyNzAtNGFiMC1hOGM2LWY5MDJiOTQ5MWZiNyIsInNjb3BlIjpbIm9wZW5pZCJdLCJvcmdhbml6YXRpb24iOm51bGwsImlzcyI6ImEzNmMzMDQ5YjM2MjQ5YTNjOWY4ODkxY2IxMjcyNDNjIiwiZXhwIjoxNjM4Njk1ODQwLCJkaXNwbGF5X25hbWUiOm51bGwsInJlZ2lvbiI6IlRMIiwiaWF0IjoxNjM2MTAzODQwODAzLCJhdXRob3JpdGllcyI6WyJjb20uY25wYy5lcGFpLm9hdXRoMnNlcnZlci5jb250cm9sbGVyLkNsaWVudENvbnRyb2xsZXIkJExhbWJkYSQ0NC8weDAwMDAwMDAwNjQwNzNjYzBANDQxZjI0ZTYiXSwianRpIjoiZThmN2VkNGYtZWExOS00MGFjLTg3MzktZjE1NDYzNDQ4OWYyIiwiY2xpZW50X2lkIjoiN2NmZjZhMWUtMTI3MC00YWIwLWE4YzYtZjkwMmI5NDkxZmI3In0.UQ2iWtWH_n8Agvh6MAObwf-uoQX2JVXyTgTbVbS3vA9_50SDAkcIERDX4R5FUT9iReHvb4YU2Wvd-quk09m0QdwLDpW6lDPZwNga0cVQ-hpgtEkZA2ftw0kVU1Km-5oCIlHVhOiOOqkJI5u3I3iNafDiBQRTrE90t9Bu4fKTJRhPW6xSi0KvMClplxFQo7sF4VttRv0K6V5Y2wDYlbuMRE1KiAzN79_H_fHbI5wf1jfgNfuhcWh1zuNR-ztOxYGfTfIhochn2GKFKVCbv5eM_G2hTYf9YuGw8bjzTk0R4yTqPxDP-fz6SHfZYwEsWbnfZOK0IWcX-nd_iATswAsamw",
      imgDialogTitle: "图件预览",
      imgDialogFullScreen: false,
      imgDialogRef: "imgDialog",
      fileDialogTitle: "文件预览",
      fileDialogFullScreen: false,
      fileDialogRef: "filDialog",
      visible: false,
      needShowProblemMenu: false,
      problemBankInfo:{},
      problemFileInfo:null,
      top: 0,
      left: 0,
      isShow: false,//表格是否展示
      json: {},//表格数据
      drawer: false,//查看详情抽屉
      drawchart: false,
      xxoo: -1,//冻结列的数量
      fileName: "",//导出文件名
      drawerLink: "",
      primaryKey:{},//数据甄别主键
      primaryKeyText:"",//数据甄别主键拼接内容
      drawerDialogVisible: false,//钻取的文件预览
      operation: "right",//操作列是否展示并浮动
      fileExportDialogVisible: false,//导出
      routeImgUrl: "",//图像预览地址
      routeDocUrl: "",//文件资源预览地址
      routeDocName: "",//文件资源预览名称
      url: require("@/assets/123.jpeg"),//图片地址
      // url2:require("@/assets/123.txt"),
      //url2:require("@/assets/abc.pdf"),
      urlList: [require("@/assets/123.jpeg")],//图片预览地址
      total1: 0,//分页
      currentPage1: 1,//当前页数
      pageSize: 20,//每页所展示的数量
      rowStyle: "",//表格行样式
      dialogFormVisible: false,//编辑整行
      problemDialogVisible: false,//数据反馈
      screeningDialogVisible:false,//数据甄别
      // xx:null,
      viewDisplay: false,
      option: {},//chart的数据
      chartType: "normal",//chart的类型：normal、wellgroup
      id: "chart_view",
      changes: {},//整行编辑时的数据
      tableHead: [],//表头
      tableHeader: [],//钻取表头
      tableDatas: [],//表格数据
      tableData: [],//钻取数据
      drawerTitle: "",//钻取标题
      screeningData:{},//甄别数据
      curSelCellInfo: {},//当前选中单元格关键属性
      curProblemData: {
        DSID: '',
        WELL_ID: '',
        WELL_COMMON_NAME: '',
        YEAR_MON: '',
        columnField: '',
        columnName: '',
        cellVal: '',
        hopeVal: '',
        remark: '',
        keyInfo: '',
        moduleid: '',
        modulename: '',
        userid: '',
        username: '',
        recordDate: new Date()
      },
      curSelRowArray: [],
      assessTemplateInfo: {},//综合整理考核评分页面所需数据

      uploadLisType:null,//数据上传类型
      uploadList_forecastTableHeader:[
        {
          id:"time",
          name:"时间",
        },
        {
          id:"data",
          name:"产量",
        }
        // ,
        // {
        //   id:"cumulative",
        //   name:"累产",
        // },
        // {
        //   id:"degree",
        //   name:"采出程度",
        // },
        // {
        //   id:"speed",
        //   name:"采油速度",
        // },
      ],//预测数据的对应表格表头信息(数据上传记录页面)
      uploadListHeader:[],//表头信息(数据上传记录页面)
      uploadListTableData:[],//报表数据(数据上传记录页面)
      uploadListExcelName:[],//文件名称(数据上传记录页面)
      fittingDatas:[],//拟合数据
      fittingMap:{"index":"指数递减",
        "hyperbolic":"双曲递减",
        "harmonic":"调和递减",
        "decline":"产量衰减",
        "linear":"线性递减"},
      fittingtype:[
        {
          label:"指数递减",
          data:"index"
        },
        {
          label:"双曲递减",
          data:"hyperbolic"
        },
        {
          label:"调和递减",
          data:"harmonic"
        },{
          label:"产量衰减",
          data:"decline"
        },{
          label:"线性递减",
          data:"linear"
        },
      ],//拟合 递减类型

      tableDataCopy:[],//报表数据备份（修改数据内容前）
      editTableList:[],//报表修改数据记录
      isInfinite:false,//无限滚动禁用标识
    }
  },
  methods: {
    webViewerDlgCommand(command){
      console.log(command)
      window.open(this.webViewrIframeUrl,'_blank')
      this.webViewrDialogVisible = false;
    },
    problemFileExceed(files){
      console.log(this.$refs.upload,files)
      this.$refs.upload.clearFiles();
      let file = files[0];
      //file.uid = genFileId();
      this.$refs.upload.handleStart(file);
    },
    problemFileChange(v){
      console.log(v.raw);
      if(v!=null && v!=undefined){
        if(v.raw !=null && v.raw != undefined){
          this.problemFileInfo = v.raw;
        }
      }
    },
    //分页大小变换
    tablesizeChange(pageSize){
      let num = this.drawerDataNum/pageSize;
      this.drawerPageCount=Math.ceil(num);
      this.drawerPageSize = pageSize;
      // let user_id = "0000001";
      let data = this.drawerData;
      let header = this.drawerHead;
      let _this = this;
      this.drawerCurrentPage = 1;
      this.tableData = [];
      this.tableHeader = [];
      // console.log("header:",header);
      if(header.type != "chart"){
        this.drawchart= true;
        var obj = {};
        obj.row = data.row;
        obj.column = data.column.property;
        obj.label = data.column.label;
        // obj.moduleId = header.router;
        obj.moduleId = obj.row[obj.column].value.router;
        if(obj.moduleId == null){
          obj.moduleId = header.router;
        }
        console.log(">>>>>>>>",obj)
        if(obj.row.datarecordId != null){
          let json = JSON.parse(JSON.stringify(obj.row).replace(/datarecordId/g,"id"))
          console.log("11111111111111111",json)
          obj.row = json;
        }
        axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/griddrill", {
          user_id: "0000001",
          moduleId: obj.moduleId,
          data: obj,
          headerType: header.type,
          page: this.drawerCurrentPage,
          size: this.drawerPageSize
        }).then(res => {
          console.log("钻取1", res.data)
          if (res.data.result != "failed") {
            _this.drawerTitle = res.data.module.moduleName;
            _this.tableData = res.data.data;
            _this.tableHeader = res.data.header;
            if(res.data.needFlowChart != undefined){
              _this.isFlowChartShow = res.data.needFlowChart;
              if(_this.isFlowChartShow){
                _this.$nextTick(() => {
                  _this.$refs.flowChart.setContainerStyle("20%");
                  if(_this.templateInfo != undefined && (_this.templateInfo.moduleid == 'e017ef7756044d3a810729b5b109f5d3' ||
                      _this.templateInfo.moduleid == '7b2896c772f7401482ce6bd8c89d370d')){
                    _this.$refs.flowChart.setNodeLabel("node4", "归档");
                  }
                  for(let idx=0;idx<_this.tableData.length;idx++){
                    console.log("chart",_this.tableData[idx])
                    if(_this.tableData[idx].OP_STATUS == "送审") {
                      _this.$refs.flowChart.setNodeLabel("node1", _this.tableData[idx].OP_USER_NAME + "\r\n[送审]");
                      _this.$refs.flowChart.setSelectNode("node2")
                      _this.$refs.flowChart.setEdgeStatus("Edge1",true);
                    }
                    else if(_this.tableData[idx].OP_STATUS == "初审通过") {
                      _this.$refs.flowChart.setNodeLabel("node2", _this.tableData[idx].OP_USER_NAME + "\r\n[初审]");
                      _this.$refs.flowChart.setSelectNode("node3")
                      _this.$refs.flowChart.setEdgeStatus("Edge2",true);
                    }
                    else if(_this.tableData[idx].OP_STATUS == "驳回") {
                      _this.$refs.flowChart.setSelectNode("node5")
                      if(idx==1){
                        _this.$refs.flowChart.setNodeLabel("node2", _this.tableData[idx].OP_USER_NAME + "\r\n[驳回]");
                        _this.$refs.flowChart.setEdgeStatus("Edge4",true);
                      }
                      else if(idx == 2){
                        _this.$refs.flowChart.setNodeLabel("node3", _this.tableData[idx].OP_USER_NAME + "\r\n[驳回]");
                        _this.$refs.flowChart.setEdgeStatus("Edge5",true);
                      }
                    }
                    else if(_this.tableData[idx].OP_STATUS == "终审通过并提交银行处理" || _this.tableData[idx].OP_STATUS == "终审通过" || _this.tableData[idx].OP_STATUS == "终审通过并归档"){
                      _this.$refs.flowChart.setNodeLabel("node3", _this.tableData[idx].OP_USER_NAME + "\r\n[终审]");
                      _this.$refs.flowChart.setSelectNode("node4")
                      _this.$refs.flowChart.setEdgeStatus("Edge3",true);
                    }
                  }
                }, 50)
              }
              console.log("钻取", this.isFlowChartShow)
            }
          } else {
            this.drawerTitle = "";
            this.tableData = [];
            this.tableHeader = [];
          }
          this.drillLoading=false;
        })
      }
    },
    //点击第几页
    currenttableChange(currentPage){
      console.log(currentPage)
      let data = this.drawerData;
      let header = this.drawerHead;
      let _this = this;
      this.drawerCurrentPage=currentPage;
      this.tableData = [];
      this.tableHeader = [];
      // console.log("header:",header);
      if(header.type != "chart"){
        this.drawchart= true;
        var obj = {};
        obj.row = data.row;
        obj.column = data.column.property;
        obj.label = data.column.label;
        // obj.moduleId = header.router;
        obj.moduleId = obj.row[obj.column].value.router;
        if(obj.moduleId == null){
          obj.moduleId = header.router;
        }
        console.log(">>>>>>>>",obj)
        if(obj.row.datarecordId != null){
          let json = JSON.parse(JSON.stringify(obj.row).replace(/datarecordId/g,"id"))
          console.log("11111111111111111",json)
          obj.row = json;
        }
        axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/griddrill", {
          user_id: "0000001",
          moduleId: obj.moduleId,
          data: obj,
          headerType: header.type,
          page: this.drawerCurrentPage,
          size: this.drawerPageSize
        }).then(res => {
          console.log("钻取2", res.data)
          if (res.data.result != "failed") {
            _this.drawerTitle = res.data.module.moduleName;
            _this.tableData = res.data.data;
            _this.tableHeader = res.data.header;
            if(res.data.needFlowChart != undefined){
              _this.isFlowChartShow = res.data.needFlowChart;
              if(_this.isFlowChartShow){
                _this.$nextTick(() => {
                  _this.$refs.flowChart.setContainerStyle("20%");
                  if(_this.templateInfo != undefined && (_this.templateInfo.moduleid == 'e017ef7756044d3a810729b5b109f5d3' ||
                      _this.templateInfo.moduleid == '7b2896c772f7401482ce6bd8c89d370d')){
                    _this.$refs.flowChart.setNodeLabel("node4", "归档");
                  }
                  for(let idx=0;idx<_this.tableData.length;idx++){
                    if(_this.tableData[idx].OP_STATUS == "送审") {
                      _this.$refs.flowChart.setNodeLabel("node1", _this.tableData[idx].OP_USER_NAME + "\r\n[送审]");
                      _this.$refs.flowChart.setSelectNode("node2")
                      _this.$refs.flowChart.setEdgeStatus("Edge1",true);
                    }
                    else if(_this.tableData[idx].OP_STATUS == "初审通过") {
                      _this.$refs.flowChart.setNodeLabel("node2", _this.tableData[idx].OP_USER_NAME + "\r\n[初审]");
                      _this.$refs.flowChart.setSelectNode("node3")
                      _this.$refs.flowChart.setEdgeStatus("Edge2",true);
                    }
                    else if(_this.tableData[idx].OP_STATUS == "驳回") {
                      _this.$refs.flowChart.setSelectNode("node5")
                      if(idx==1){
                        _this.$refs.flowChart.setNodeLabel("node2", _this.tableData[idx].OP_USER_NAME + "\r\n[驳回]");
                        _this.$refs.flowChart.setEdgeStatus("Edge4",true);
                      }
                      else if(idx == 2){
                        _this.$refs.flowChart.setNodeLabel("node3", _this.tableData[idx].OP_USER_NAME + "\r\n[驳回]");
                        _this.$refs.flowChart.setEdgeStatus("Edge5",true);
                      }
                    }
                    else if(_this.tableData[idx].OP_STATUS == "终审通过并提交银行处理" || _this.tableData[idx].OP_STATUS == "终审通过" || _this.tableData[idx].OP_STATUS == "终审通过并归档"){
                      _this.$refs.flowChart.setNodeLabel("node3", _this.tableData[idx].OP_USER_NAME + "\r\n[终审]");
                      _this.$refs.flowChart.setSelectNode("node4")
                      _this.$refs.flowChart.setEdgeStatus("Edge3",true);
                    }
                  }
                }, 50)
              }
              console.log("钻取", this.isFlowChartShow)
            }
          } else {
            this.drawerTitle = "";
            this.tableData = [];
            this.tableHeader = [];
          }
          this.drillLoading=false;
        })
      }

    },
    //获取数据甄别主键
    getPrimary(){
      console.log(this.templateInfo)

      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      let pageId = this.templateInfo.pageid;
      let url = process.env.VUE_APP_SERVER +"/dataprovider/businessdata/screen/major?pageId="+pageId;
      axios.get(url,{
        headers:{"authorization": "Bearer " + token}
      })
        .then(res=>{
          console.log("123123123123",res.data.data)
          this.primaryKey = res.data.data
            console.log(this.templateInfo)
            this.primaryKeyText ="";
            this.primaryKey.keyColumnCode.forEach(item =>{
                // console.log(item)
                // console.log(this.screeningData)
                // console.log(this.screeningData[item])
                this.primaryKeyText += this.screeningData[item].value.name
                this.primaryKeyText += " ";
            })
            let pageId = this.templateInfo.pageid;
            console.log(pageId);
            this.screeningData.use = true;
            this.screeningData.remark = "";
            this.screeningDialogVisible = true;
            console.log(this.screeningData)
            console.log(123)

        })
    },
    filterHandler(value,row,column){
      return row[column.property].value.name=== value
    },
    getHeadFilter(item){
      let filters = null;
      if(item.TABLE_NAME == 'TLM_BANK_WELL_DEVI_INTER_V'){
        if(item.label=='测斜方式'){
          filters = [{ text: '电测'          , value: '电测' },
            { text: '电子多点'       , value: '电子多点' },
            { text: '无线随钻'       , value: '无线随钻' },
            { text: '未知'           , value: '未知' },
            { text: ' '              , value: ' ' },
            { text: '单点'           , value: '单点' },
            { text: '多点'           , value: '多点' },
            { text: '投多点仪器测斜' , value: '投多点仪器测斜' },
            { text: '有线随钻'       , value: '有线随钻' },
            { text: 'CSU'            , value: 'CSU' },
            { text: '完井电测'       , value: '完井电测' },
            { text: '多点测斜'       , value: '多点测斜' },
            { text: '测井'           , value: '测井' },
            { text: '陀螺'           , value: '陀螺' },
            { text: '801电测'        , value: '801电测' },
            { text: '随钻'           , value: '随钻' },
            { text: '电缆测斜'       , value: '电缆测斜' },
            { text: '西安测井'       , value: '西安测井' },
            { text: '中油测井'       , value: '中油测井' },
            { text: 'csu'            , value: 'csu' },
            { text: '虹吸'           , value: '虹吸' },
            { text: 'SJD801电测'     , value: 'SJD801电测' },
            { text: '5700测'         , value: '5700测' },
            { text: '套管内测井'     , value: '套管内测井' },
            { text: '电子单点'       , value: '电子单点' },
            { text: '固井电测'       , value: '固井电测' },
            { text: '中途电测'       , value: '中途电测' },
            { text: '电测5700系列'   , value: '电测5700系列' },
            { text: '连续测斜'       , value: '连续测斜' },
            { text: 'ESS'            , value: 'ESS' },
            { text: '电测斜'         , value: '电测斜' },
            { text: 'USB'            , value: 'USB' },
            { text: '单点照相'       , value: '单点照相' },
            { text: 'CUS'            , value: 'CUS' },
            { text: '投测'           , value: '投测' },
            { text: 'MWD'            , value: 'MWD' },
            { text: '测多点'         , value: '测多点' },
            { text: '测井数据'       , value: '测井数据' },
            { text: 'ECLIPS-5700'    , value: 'ECLIPS-5700' },
            { text: 'PowerV'         , value: 'PowerV' },
            { text: '加点'           , value: '加点' },
            { text: '电测801'        , value: '电测801' },
            { text: '吊测'           , value: '吊测' },
            { text: '有磁多点投测'   , value: '有磁多点投测' },
            { text: '对比电测'       , value: '对比电测' },
            { text: '完井转入电测'   , value: '完井转入电测' },
            { text: '自符式电子单点' , value: '自符式电子单点' },
            { text: '常规测井'       , value: '常规测井' },
            { text: '单点照像'       , value: '单点照像' },
            { text: '电测连斜'       , value: '电测连斜' },
            { text: '801'            , value: '801' },
            { text: '侧斜方式'       , value: '侧斜方式' },
            { text: '单点测斜'       , value: '单点测斜' },
            { text: 'TOTCO'          , value: 'TOTCO' },
            { text: 'UCB'            , value: 'UCB' },
            { text: '单点投测'       , value: '单点投测' },
            { text: 'powerv'         , value: 'powerv' },
            { text: '电子小多点'     , value: '电子小多点' },
            { text: 'MMWD'           , value: 'MMWD' },
            { text: 'ESS多点'        , value: 'ESS多点' },
            { text: '3700电测'       , value: '3700电测' },
            { text: 'LWD测井'        , value: 'LWD测井' },
            { text: 'CSD'            , value: 'CSD' },
            { text: '自浮式单点'     , value: '自浮式单点' },
            { text: '陀螺侧斜'       , value: '陀螺侧斜' },
            { text: '测斜方式'       , value: '测斜方式' },
            { text: 'TOTCD'          , value: 'TOTCD' },
            { text: '虹吸 TOTCO'     , value: '虹吸 TOTCO' },
            { text: '自浮式电子单点' , value: '自浮式电子单点' },
            { text: '自浮'           , value: '自浮' },
            { text: '吊测、单点照相' , value: '吊测、单点照相' },
            { text: '自浮式单点测斜' , value: '自浮式单点测斜' },
            { text: 'MMWD随钻'       , value: 'MMWD随钻' },
            { text: '虹测'           , value: '虹测' },
            { text: '单点打孔'       , value: '单点打孔' },
            { text: '多点测斜仪'     , value: '多点测斜仪' },
            { text: '直线随钻'       , value: '直线随钻' },
            { text: '电子多点测斜'   , value: '电子多点测斜' },
            { text: 'power-v'        , value: 'power-v' },
            { text: '单点自浮'       , value: '单点自浮' },
            { text: '虹吸投测'       , value: '虹吸投测' },
            { text: '自浮单点'       , value: '自浮单点' },
            { text: '完钻电测'       , value: '完钻电测' },
            { text: '技测'          , value: '技测' }];
        }
        else if(item.label=='阶段'){
          filters = [{ text: '测井', value: '测井' },{ text: '钻井', value: '钻井' },{ text: '未知', value: '未知' }];
        }
      }
      return filters;
    },
    getHeadWidth(item){
      if(this.needReCalColWidth) {
        //不是数值或为0则elmui自动处理，否则返回指定宽度
        return parseFloat(item.WIDTH).toString() == "NaN"?undefined:(item.WIDTH===0?undefined:item.WIDTH);
      }
      // console.log("tbctrl.item",item)
      let width = item.WIDTH==='AUTO'?(item.label.length+2-(item.label.includes('(')&&item.label.includes(')')?item.label.indexOf(')')-item.label.indexOf('('):0))*26:item.WIDTH===0?undefined:item.WIDTH;
      if(item.WIDTH ===0||item.WIDTH ===undefined)
        width = (item.label.length+2-(item.label.includes('(')&&item.label.includes(')')?(item.label.indexOf(')')-item.label.indexOf('('))*0.5:0))*23;
      // console.log(width)
      return width;
    },
    sort(a,b,c){
      // if(a[c] == undefined)
      //   return 1;
      // return a[c].value.name-b[c].value.name;
      if(a[c].value == null){
        return 1;
      }
      if(b[c].value == null){
        return -1
      }
      if(typeof(a[c].value)=="object"){
        return a[c].value.name - b[c].value.name;
      }else{
        if(parseInt(a[c].value).toString() =="NaN"){
          let re= /[\u4E00-\u9FA5]/;
          let aa= a[c].value.split("")
          aa = aa[0];
          let bb= b[c].value.split("")
          bb = bb[0];
          console.log(re.test(aa))
          if (re.test(aa)){
            return a[c].value.localeCompare(b[c].value, 'zh-Hans-CN') //中文排序方法
          }else{
            console.log(isNaN(Number((a[c].value))))
            console.log(Number((a[c].value)))
            return aa.toLowerCase().charCodeAt() - bb.toLowerCase().charCodeAt()
          }
        }else{
          if(a[c].value.length< 10){//根据长度判断是否为日期
            return a[c].value - b[c].value
          }else{
            return Date.parse(a[c].value) - Date.parse(b[c].value)
          }

        }
      }
    },
    //获取配置好的表格数据
    getData(d) {
      this.json = {};
      this.json = d;
      if (this.json.header.length == 0) {
        this.loading=false
        return
      }
      this.isShow = true;
      if (d.xxoo != -1) {
        this.tableFixed(d.xxoo)
      } else {
        this.RemoveFixed();
      }
      if (d.clickNum == 0) {
        this.useEdit();
      }
      this.$nextTick(() => {
        if(document.getElementById("table") && document.getElementsByClassName("el-table__header") && !this.needReCalColWidth) {
          let maxWidth = document.getElementById("table").offsetWidth;//屏幕宽度
          let tbTrueWidth = document.getElementsByClassName("el-table__header").item(0).clientWidth;//报表宽度
          this.needReCalColWidth = maxWidth ==0?false:maxWidth - tbTrueWidth > 10;
        }
      },100);
      this.loading=false
      console.log("看这里", this.json);
      this.tableDataCopy=JSON.parse(JSON.stringify(this.json.data));
      this.$nextTick(() => {
        console.log("relayout")
        //报表的key值变化后，会刷新报表，以解决固定行初始化加载错位的问题
        this.tableKey++;
        this.$nextTick(() => {
          this.addOnscroll();
        },50)
        // this.tableKey--;
        //强制重新渲染视图 使用key值 vue会删除旧组件并创建新组件，它将重新初始化自身并“重置”其状态，导致挂载的事件失效
        // this.$forceUpdate
      },100);
    },
    xxoo1(row, column, cell, event) {
      console.log(row, column, cell, event)
    },
    //打开子母表
    openDetail(data,header) {
        console.log("data+++++++",data)
        console.log("header+++++++",header)
      //如果是综合整理考核评分页面则跳转其他方法
      if (this.$parent.$parent.$parent.$props.templateInfo!=undefined && this.$parent.$parent.$parent.$props.templateInfo.type == 'table_assess') {
        this.seeAssessdata(data);
        return
      }
      //指标安排,考核指标上报 上传记录页面的详情字段，进入此方法
      console.log("drill1",this.$parent.$parent.$parent.$props.uploadList,data.column.property)
      if (this.$parent.$parent.$parent.$props.uploadList && data.column.property=="dataDrilling")
      {
       this.seeUploadListdata(data);
        return;
      }
      console.log("drillTemplate",this.templateInfo.pageid)
      //完成情况，指标分析 上传记录页面
      if (this.templateInfo.pageid=="1dd1dab5bb094000b3ef02186ba1762a" || this.templateInfo.pageid=="a0e44b950ba148a38030f4ada15e24e5"){
        this.uploadListDialogVisible = true;//弹出框显示
        this.uploadListHeader = data.row.DATA_FORECAST.value.header;
        this.uploadListTableData = data.row.DATA_FORECAST.value.data;
        this.uploadListExcelName = data.row.PAGE_NAME.value.name + data.row.CREATION_DATE.value.name.substring(0, 10);
        console.log("data:",this.uploadListTableData)
        console.log("header:",this.uploadListHeader)
        console.log("excelName:",this.uploadListExcelName)
        return;
      }
      this.drawerData = data;
      this.drawerHead = header;
      let _this = this;
      this.isFlowChartShow = false;
      this.drawer = true;
      this. drillLoading=true;
      // 先清空缓存数据
      this.drawchart= false;
      this.viewDisplay = false;
      this.drawerTitle = "";
      this.tableData = [];
      this.tableHeader = [];
      // console.log("header:",header);
      if(header.type != "chart"){
        this.drawchart= true;
        var obj = {};
        obj.row = data.row;
        obj.column = data.column.property;
        obj.label = data.column.label;
        // obj.moduleId = header.router;
        obj.moduleId = obj.row[obj.column].value.router;
        if(obj.moduleId == null){
          obj.moduleId = header.router;
        }
        console.log(">>>>>>>>",obj)
        if(obj.row.datarecordId != null){
          let json = JSON.parse(JSON.stringify(obj.row).replace(/datarecordId/g,"id"))
          console.log("11111111111111111",json)
          obj.row = json;
        }
        axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/griddrill", {
          user_id: "0000001",
          moduleId: obj.moduleId,
          data: obj,
          headerType: header.type,
          page: this.drawerCurrentPage,
          size: this.drawerPageSize,
          total: true
        }).then(res => {
          console.log("钻取3", res.data)
          if (res.data.result != "failed") {
            _this.drawerTitle = res.data.module.moduleName;
            _this.tableData = res.data.data;
            _this.tableHeader = res.data.header;
            _this.drawerDataNum = res.data.totalElements;
            if(res.data.needFlowChart != undefined){
              _this.isFlowChartShow = res.data.needFlowChart;
              if(_this.isFlowChartShow){
                _this.$nextTick(() => {
                  _this.$refs.flowChart.setContainerStyle("20%");
                  if(_this.templateInfo != undefined && (_this.templateInfo.moduleid == 'e017ef7756044d3a810729b5b109f5d3' ||
                      _this.templateInfo.moduleid == '7b2896c772f7401482ce6bd8c89d370d')){
                    _this.$refs.flowChart.setNodeLabel("node4", "归档");
                  }
                  for(let idx=0;idx<_this.tableData.length;idx++){
                    if(_this.tableData[idx].OP_STATUS == "送审") {
                      _this.$refs.flowChart.setNodeLabel("node1", _this.tableData[idx].OP_USER_NAME + "\r\n[送审]");
                      _this.$refs.flowChart.setSelectNode("node2")
                      _this.$refs.flowChart.setEdgeStatus("Edge1",true);
                    }
                    else if(_this.tableData[idx].OP_STATUS == "初审通过") {
                      _this.$refs.flowChart.setNodeLabel("node2", _this.tableData[idx].OP_USER_NAME + "\r\n[初审]");
                      _this.$refs.flowChart.setSelectNode("node3")
                      _this.$refs.flowChart.setEdgeStatus("Edge2",true);
                    }
                    else if(_this.tableData[idx].OP_STATUS == "驳回") {
                      _this.$refs.flowChart.setSelectNode("node5")
                      if(idx==1){
                        _this.$refs.flowChart.setNodeLabel("node2", _this.tableData[idx].OP_USER_NAME + "\r\n[驳回]");
                        _this.$refs.flowChart.setEdgeStatus("Edge4",true);
                      }
                      else if(idx == 2){
                        _this.$refs.flowChart.setNodeLabel("node3", _this.tableData[idx].OP_USER_NAME + "\r\n[驳回]");
                        _this.$refs.flowChart.setEdgeStatus("Edge5",true);
                      }
                    }
                    else if(_this.tableData[idx].OP_STATUS == "终审通过并提交银行处理" || _this.tableData[idx].OP_STATUS == "终审通过" || _this.tableData[idx].OP_STATUS == "终审通过并归档"){
                      _this.$refs.flowChart.setNodeLabel("node3", _this.tableData[idx].OP_USER_NAME + "\r\n[终审]");
                      _this.$refs.flowChart.setSelectNode("node4")
                      _this.$refs.flowChart.setEdgeStatus("Edge3",true);
                    }
                  }
                }, 50)
              }
              console.log("钻取", this.isFlowChartShow)
            }
          } else {
            this.drawerTitle = "";
            this.tableData = [];
            this.tableHeader = [];
          }
          this.drillLoading=false;
        })
      }
      else {
        _this.viewDisplay = true
        let user_id = "0000001";
        let app_id = header.router;
        let well = [];
        well.push(data.row[data.column.property].value["name"]);
        let token = localStorage.getItem("lyqtJwt");
        // let wellname = data.row[data.column.property].value["name"];
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/chartConfigData",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            user_id: user_id,
            app_id: app_id,
            wellSingle: well,
            token: token,
          }
        }).then(res=>{
          //_this.config_name = _this.switch_config_name;
          if(res.data.data != undefined) {
            _this.config_name = res.data.data.config_name;
            _this.option = res.data.data.config;
            _this.chartNum = _this.option.length;
            _this.configModify++;
            _this.changeConfigNow=res.data.data.config_name;
            _this.chartType = res.data.data.chart_type;
            let len=res.data.data.config[0].xAxis.userCategory.length;
            _this.frameTime=[res.data.data.config[0].xAxis.userCategory[0],res.data.data.config[0].xAxis.userCategory[len-1]];
            // _this.$forceUpdate();
          }
         else {
            ElMessageBox("钻取数据为空！");
          }
          this.drillLoading=false;

        }).catch(err=>{
          this.drillLoading=false;
          console.log(err)
        });

      }
      console.log("option!!!!!",_this.option)

    },
    //综合整理考核评分页面查看算法配置
    seeAssessdata(data){
      this.assessDialogVisible=true;//弹出框显示
      this.assessTemplateInfo.YEAR_MON=data.row.YEAR_MON.value.name;//年份信息
      console.log(this.assessTemplateInfo)
    },
    //指标安排 上传记录页面 查看详情字段
    seeUploadListdata(data) {
      console.log( "0",data);
      this.uploadListDialogVisible = true;//弹出框显示
      this.uploadListHeader = [];
      this.uploadListTableData = [];
      this.fittingDatas = [];
      this.uploadLisType = data.row.upload_type.value;
      if(this.uploadLisType == undefined){
        this.uploadLisType = data.row.upload_type;
      }
      console.log( "1",this.uploadLisType);
      console.log( "2",data.row);
      if (this.uploadLisType == "预测数据") {
        if(data.row.dataDrilling.value != undefined){
          let tableData = data.row.dataDrilling.value.data;
          this.uploadListHeader = this.uploadList_forecastTableHeader;
          this.uploadListTableData = tableData[0].forecastTableData;
          this.fittingDatas.push(tableData[0].fittingData);
        }
        else{
          let tableData = data.row.dataDrilling.data;
          this.uploadListHeader = this.uploadList_forecastTableHeader;
          this.uploadListTableData = tableData[0].forecastTableData;
          this.fittingDatas.push(tableData[0].fittingData);
        }
      }
      else if (this.uploadLisType == "文件导入数据" || this.uploadLisType == "录入数据") {
        // console.log( "2",data.row.dataDrilling);
        if(data.row.dataDrilling.value == undefined){
          this.uploadListHeader = data.row.dataDrilling.head;
          this.uploadListTableData = data.row.dataDrilling.data;
          this.uploadListExcelName = data.row.EXCELNAME != undefined && data.row.EXCELNAME != null ? data.row.EXCELNAME : data.row.page_name;
          this.uploadListExcelName += data.row.creation_date != undefined ? data.row.creation_date.substring(0, 10) : data.row.creationDate.substring(0, 10);
        }
        else {
          this.uploadListHeader = data.row.dataDrilling.value.head;
          this.uploadListTableData = data.row.dataDrilling.value.data;
          this.uploadListExcelName = data.row.EXCELNAME != undefined && data.row.EXCELNAME.value != null ? data.row.EXCELNAME.value : data.row.page_name.value;
          this.uploadListExcelName += data.row.creation_date != undefined ? data.row.creation_date.value.substring(0, 10) : data.row.creationDate.value.substring(0, 10);
        }
      }
      // console.log(this.uploadListHeader);
    },
    drawerClick(data,scope) {
      if(data == null) return ;
      console.log("drawerClick",scope,data);
      let dowloadfileName = 'default';
      switch (data.type) {
        case "word":
        case "excel":
          this.showTxt2(data.name, data.link);
          break;
        case "imageRoute":
          this.showRouteImage(data.link,scope);
          break;
        case "webRoute":
          this.showWebViewer(data.link,scope);
          break;
        case "gmpRoute":
          this.showGmpImage(data.link,scope);
          break;
        // case "downloadfile":
        //   window.location.href = data.link;
        //   break;
        case "drillUploadReview":
          this.seeUploadListdata(scope);
          break;
        default:
          if(scope.row[scope.column.property].value != undefined){
            if(scope.row[scope.column.property].value.name != undefined) {
              dowloadfileName = scope.row[scope.column.property].value.name;
            }
          }
          else if(scope.row[scope.column.property].name != undefined){
            dowloadfileName = scope.row[scope.column.property].name;
          }
          this.downloadfile(data.link,dowloadfileName);
          //window.location.href = data.link;
          //this.showRouteImage(data.link,scope);
          // this.drawerLink = data.link;
          // this.drawerDialogVisible = true;
          break;
      }
    },
    downloadfile(url,name){
      console.log("downloadFileNow")
      fetch(url)
          .then((res) => { if(res.ok) { return res.blob() } })
          .then((blob) => {
            if(blob==undefined)
            {
              ElMessage("服务器文件不存在!")
            }
            else{
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = name;
              a.target = "_blank";
              a.click();
              a.remove();
            }
          })
      // const newUrl = url;
      // const x = new XMLHttpRequest();
      // x.open("GET",newUrl,true);
      // x.responseType = "blob";
      // x.onload = () => {
      //   console.log(123)
      //   const url = URL.createObjectURL(x.response);
      //   console.log(url)
      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = name;
      //   a.target = "_blank";
      //   a.click();
      //   a.remove();
      // }
    },
    downloadByBlob(url, name) {
      //第一个参数是图片链接，第二个参数是图片名称
      let image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = url;
      image.onload = () => {
        let canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        let ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, image.width, image.height);
        canvas.toBlob((blob) => {
          let url = URL.createObjectURL(blob);
          this.download(url, name);
          // 用完释放URL对象
          URL.revokeObjectURL(url);
        });
      };
    },
    download(href, name) {
      let eleLink = document.createElement('a');
      eleLink.download = name;
      eleLink.href = href;
      eleLink.click();
      eleLink.remove();
    },
    //打开导出窗口
    files() {
      this.fileExportDialogVisible = true;
    },
    doContextMenu() {
      // _this.curSelCellInfo
      this.problemDialogVisible = true;
    },
    //数据甄别
    dataScreening(){
      this.getPrimary();
    },
    //数据甄别
    dataScreenOk(){
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      let pageId = this.templateInfo.pageid;
      let data = {};
      let primary = this.primaryKey;
      console.log(primary)
      data.authorization = token;
      data.pageId =  pageId;
      data.primaryKey = [];
      data.keyColumnCode = "";
      primary.keyColumnCode.forEach(item=>{
          data.keyColumnCode += item;
          data.keyColumnCode += ",";
      })
      data.keyColumnCode = data.keyColumnCode.slice(0,data.keyColumnCode.length-1);
      console.log("primary.keyColumnCode",primary.keyColumnCode)
      data.datsrcName = primary.datsrcName;
      data.dataUrl = primary.dataUrl;
      data.pageName= primary.pageName;
      data.isEnable = this.screeningData.use==true?0:1;   //0为可用
      console.log(primary)
      let text = "";
      primary.keyColumnCode.forEach(item =>{
          console.log(this.screeningData[item].value.name)
          text += this.screeningData[item].value.name;
          text += ",";
      })
        text = text.slice(0,text.length-1);
      data.primaryKey.push({
        primary:text,
        reason:this.screeningData.remark
      });
      console.log(data)
      let url = process.env.VUE_APP_SERVER+"/dataprovider/businessdata/screen/add";
      console.log(url)
      axios.post(url,data)
        .then(res=>{
          console.log(res)
          ElMessage(res.data.msg)
          this.screeningDialogVisible = false;
        })
    },
    //自用模板配置修改
    tmpDoTemplateChange() {
      // _this.curSelCellInfo
      console.log("CurGridCfg:",this.gridCfg);
      console.log("CurGridTmpInfo:",this.templateInfo);
    },
    //导出页面点击确定
    fileOk() {
      if (this.fileName == "") {
        ElMessage("请输入文件名")
        return
      }
      var fix = document.querySelector('.el-table__fixed');
      var exportTable;
      if(fix){
        exportTable = XLSX.utils.table_to_book(document.getElementById('table').removeChild(fix));
        document.getElementById('table').appendChild(fix);
      }else{
        exportTable = XLSX.utils.table_to_book(document.getElementById('table'));
      }
      var exportTableOut = XLSX.write(exportTable, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([exportTableOut], { type: 'application/octet-stream' }), this.fileName+'.xlsx')
        this.fileName = "";
        this.fileExportDialogVisible = false;

      } catch (e) {
        if (typeof console !== 'undefined'){
          console.log(e, exportTableOut)
          this.fileName = "";
          this.fileExportDialogVisible = false;
          ElMessage("文件导出失败,请稍后再试")
        }
      }
      return exportTableOut
    },
    //报表文件导出函数
    exportTable(type) {
      let excelName = "钻取数据";
      if (type == "upload")
        excelName = this.uploadListExcelName.replace('.xlsx', '');
      if (type == "drill"){
        excelName = this.drawerHead.drillname;
        if (this.drawerTitle!=""){
          excelName=this.drawerTitle;
        }
      }
      _exportTable(excelName)
    },
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        // 避免 200 from disk cache
        url = url + `?r=${Math.random()}`
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send()
      }).catch((e)=>{console.log("promiseCatch",e)})
    },
//文件下载
    fileDownload(scope) {
      // var filename = prompt("请输入文件名", data.name);
      // FileSaver.saveAs(this.getBlob(data.link), filename);
      // var a = document.createElement('a');
      // a.href=data;
      // a.download = filename;
      // a.click();
      let data;
      if (scope.row == undefined) {
        data = scope;
      } else {
        data = scope.row[scope.column.property].value;
      }
      //window.location.href = data.link;
      console.log("download",data);
      let filename = data.name;
      if(filename == undefined) filename = "default";
      this.downloadfile(data.link,filename);
    },
    handleRowDbClick(row, column, event){
      console.log("rowDbClick",row,column,event)
      if(this.showRouteIn) {
        if (row != undefined && row != null) {
          if (row.gfwdname != undefined && row.gfwdname != null) {
            let data = row.gfwdname.value.link;
            let type = row.gfwdname.value.type;
            let scope = {row:row,column:{property:'gfwdname'}};
            console.log(data,type,scope)
            switch (type) {
              case "imageRoute":
                this.showRouteImageWithoutImg(data, scope);
                break;
              case "downloadfile":
                this.showGmpImageWithoutImg(data, scope);
                break;
              case "word":
                this.showTxtWithoutImg(scope);
                break;
            }
          }
        }
      }
    },
    //GMP文件预览
    showGmpImage(data,scope) {
      ElMessageBox.confirm("下载成果还是查看？", '注意', {
        distinguishCancelAndClose: true,
        confirmButtonText: '查看',
        cancelButtonText: '下载',
        type: 'warning',
      }).then(() => {
            let _this = this;
            this.loading = true;
            console.log("GMP数据信息：");
            console.log(data);
            // _this.routeImgUrl = process.env.VUE_APP_IMGPATH +data.row["path"].value;
            // console.log(_this.routeImgUrl );
            let jwtSession = localStorage.getItem("lyqtJwt");
            if (jwtSession == null) jwtSession = "";
            _this.jwtStr = jwtSession;
            axios({
              url: process.env.VUE_APP_SERVER + "/fileprocesser/getSvgByGmp",
              method: 'POST',
              headers: {
                "Authorization": "Bearer " + _this.jwtStr
              },
              data: {
                "gmpUrl": data
              }
            }).then((res) => {
              if (res.data.success) {
                _this.routeImgUrl = res.data.svgURL;
                if(!this.showRouteIn){
                  _this.imgDialogVisible = true;
                }
                else{
                  _this.showRouteOutEvent("gmp",_this.routeImgUrl);
                }
              }
              this.loading = false;
              console.log(res.data.msg)
            }).catch((err) => {
              alert('Error');
              console.log(err)
              this.loading = false;
            })
          }
      ).catch((action) => {
        if(action == "cancel") {
          console.log("下载！")
          //window.location.href = data;
          let gmpName = 'default.gmp';
          if (scope.row[scope.column.property].value != undefined) {
            if (scope.row[scope.column.property].value.name != undefined) {
              gmpName = scope.row[scope.column.property].value.name;
            }
          } else if (scope.row[scope.column.property].name != undefined) {
            gmpName = scope.row[scope.column.property].name;
          }
          this.downloadfile(data, gmpName);
        }
      })
    },
    showGmpImageWithoutImg(data,scope) {
      let _this = this;
      this.loading = true;
      console.log("GMP数据信息：");
      console.log(data,scope);
      // _this.routeImgUrl = process.env.VUE_APP_IMGPATH +data.row["path"].value;
      // console.log(_this.routeImgUrl );
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      _this.jwtStr = jwtSession;
      axios({
        url: process.env.VUE_APP_SERVER + "/fileprocesser/getSvgByGmp",
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + _this.jwtStr
        },
        data: {
          "gmpUrl": data
        }
      }).then((res) => {
        if (res.data.success) {
          _this.routeImgUrl = res.data.svgURL;
          if(!this.showRouteIn){
            _this.imgDialogVisible = true;
          }
          else{
            _this.showRouteOutEvent("gmp",_this.routeImgUrl);
          }
        }
        this.loading = false;
        console.log(res.data.msg)
      }).catch((err) => {
        alert('Error');
        console.log(err)
        this.loading = false;
      })
    },
    //预览base64格式图片
    onPreViewImg64(scopeValue){
      this.img64PreviewUrl = 'data:image/png;base64,'+scopeValue.name;
      this.showImg64PreViewer = true;
      console.log(scopeValue)
    },
    closePreViewImg64(){
      console.log(this.showImg64PreViewer)
      this.showImg64PreViewer = false;
    },
//文件预览
    showWebViewer(data,scope) {
      ElMessageBox.confirm(
      '下载成果还是查看？',
      '注意',
      {
        distinguishCancelAndClose: true,
        confirmButtonText: '查看',
        cancelButtonText: '下载',
        draggable: true,
        type: 'warning',
      }
  )
      .then(() => {
        let _this = this;
        let jwtSession = localStorage.getItem("lyqtJwt");
        if (jwtSession == null) jwtSession = {};
        if (jwtSession.length > 0) {
          _this.webViewrIframeUrl = data+"?jwt="+jwtSession;
          console.log(data);
          _this.webViewrDialogVisible = true
        }
      })
      .catch((action) => {
        if(action == "cancel"){
          let jwtSession = localStorage.getItem("lyqtJwt");
          if (jwtSession == null) jwtSession = {};
          if (jwtSession.length > 0) {
            console.log("下载！", scope)
            let picName = 'default.png';
            if (scope.row[scope.column.property].value != undefined) {
              if (scope.row[scope.column.property].value.name != undefined) {
                picName = scope.row[scope.column.property].value.name;
              }
            } else if (scope.row[scope.column.property].name != undefined) {
              picName = scope.row[scope.column.property].name;
            }
            let downloaUrl = data.replace("preview/", "") + "?jwt=" + jwtSession
            this.downloadfile(downloaUrl, picName);
          }
        }
      })
    },
//文件预览
    showRouteImage(data,scope) {
      ElMessageBox.confirm("下载成果还是查看？", '注意', {
        distinguishCancelAndClose: true,
        confirmButtonText: '查看',
        cancelButtonText: '下载',
        draggable:true,
        type: 'warning',
      }).then(() => {
        let _this = this;
        console.log("图片导航数据信息：",data,scope);
        _this.routeImgUrl = data;
        console.log(data);
        // _this.routeImgUrl = process.env.VUE_APP_IMGPATH +data.row["path"].value;
        // console.log(_this.routeImgUrl );
        // _this.imgDialogVisible = true
        if(!this.showRouteIn){
          _this.imgDialogVisible = true;
        }
        else{
          _this.showRouteOutEvent("img",_this.routeImgUrl);
        }
        // this.$nextTick(()=>{
        //   console.log(_this.$refs.frameview);
        //   _this.$refs.frameview.postMessage(
        //       {
        //         command: "initFile",
        //         type: "url",
        //         readOnly: true,
        //         data: {fileSourceUrl: "http://gateway.dev.tlmyt.petrochina/fileprocesser/f/doc\\3wUTGhnnhuwIoa4EygCMq.doc",
        //           fileFullName: "docviewTest.doc"}
        //       },
        //       "*"
        //   );
        // },50)
      }).catch((action) => {
        if(action == "cancel") {
          console.log("下载！", scope)
          let picName = 'default.png';
          if (scope.row[scope.column.property].value != undefined) {
            if (scope.row[scope.column.property].value.name != undefined) {
              picName = scope.row[scope.column.property].value.name;
            }
          } else if (scope.row[scope.column.property].name != undefined) {
            picName = scope.row[scope.column.property].name;
          }
          this.downloadByBlob(data, picName);
          //window.location.href = data;
        }
      })
    },
    showRouteImageWithoutImg(data,scope) {
      let _this = this;
      console.log("图片导航数据信息：",data,scope);
      _this.routeImgUrl = data;
      console.log(data);
      // _this.routeImgUrl = process.env.VUE_APP_IMGPATH +data.row["path"].value;
      // console.log(_this.routeImgUrl );
      // _this.imgDialogVisible = true
      if(!this.showRouteIn){
        _this.imgDialogVisible = true;
      }
      else {
        _this.showRouteOutEvent("img", _this.routeImgUrl);
      }
    },
//文件预览
    showTxt(scope) {
      this.showTxt2(scope.row[scope.column.property].value.name, scope.row[scope.column.property].value.link);
    },
    showTxt2(name, link) {
      ElMessageBox.confirm("下载成果还是查看？", '注意', {
        distinguishCancelAndClose: true,
        confirmButtonText: '查看',
        cancelButtonText: '下载',
        type: 'warning',
      }).then(() => {
        let _this = this;
        _this.routeDocUrl = link;
        _this.routeDocName = name;
        // _this.docurl = _this.routeDocUrl;
        // _this.docName = _this.routeDocName;
        console.log(_this.routeDocName, _this.routeDocUrl);
        _this.fileDialogVisible = true;
        this.$nextTick(() => {
          ElMessage("文档在线展示根据文件大小耗时可能较长，请耐心等待!")
          docShow(link, name);
        }, 50)
        // this.$nextTick(()=>{
        //   let transData = {
        //     projectId: '',
        //     entityId: "",
        //     fileSourceUrl: _this.routeDocUrl,//"http://gateway.dev.tlmyt.petrochina/fileprocesser/f/doc/3wUTGhnnhuwIoa4EygCMq.doc",
        //     fileFullName: _this.routeDocName
        //   }
        //   console.log(transData);
        //   window.frames[0].postMessage(
        //       {
        //         command: "initFile",
        //         type: "url",
        //         readOnly: true,
        //         data: transData
        //       },
        //       "*"
        //   )
        // },50)
      }).catch((action) => {
        if(action == "cancel") {
          console.log("下载！")
          //window.location.href = link;

          this.downloadfile(link, name);
        }
      })
    },
    showTxtWithoutImg(scope) {
      let _this = this;
      let name=scope.row[scope.column.property].value.name;
      let link=scope.row[scope.column.property].value.link;
      _this.routeDocUrl = link;
      _this.routeDocName = name;
      // _this.docurl = _this.routeDocUrl;
      // _this.docName = _this.routeDocName;
      console.log(_this.routeDocName, _this.routeDocUrl);
      console.log(_this.docShowIframeUrl);
      if(!this.showRouteIn) {
        _this.fileDialogVisible = true;
        this.$nextTick(() => {
          ElMessage("文档在线展示根据文件大小耗时可能较长，请耐心等待!")
          docShow(link, name);
          //
        }, 50)
      }
      else{
        _this.showRouteOutEvent("doc",link,name,this.docShowIframeUrl);
      }
    },
//表格数据加载筛选
    showxx(scope, bb) {
      // console.log("scope1:",scope);
      let aa = scope.row[scope.column.property];
      if (aa == undefined) {
        return 0
      }
      let xx = aa[bb];
      return xx;
    },
    //报表表头行样式
    warningHeaderStyle({column}){
      if (this.$store.state.warningList.length != 0) {
        for (let i in this.$store.state.warningList) {
          if (column.property == this.$store.state.warningList[i].data) {
            return 'color : red'
          }
        }
      }
      let style = {
        background: "#f4f6f8",
        height: "36px",
        fontSize: "14px",
        fontcolor: "#333333",
        fontWeight: "bold",
        border: "1px solid #e5e5e5",
        textAlign: "center",
      }
      return style;
    },
    //报表内容行样式(单元格)
    warningCellStyle({ row, column, rowIndex}){
      // console.log({ row, column, rowIndex})
      //console.log({ row, column, rowIndex, columnIndex})
      if(this.$store.state.warningList.length != 0){
        for(let i in this.$store.state.warningList){
          if (Object.prototype.hasOwnProperty.call(row,"JH")) {
            if(row.JH.value.name == this.$store.state.warningList[i].JH){
              if(column.property == this.$store.state.warningList[i].data){
                return 'color : red'
              }
            }
          }
          else if(Object.prototype.hasOwnProperty.call(row,"WELL_LEGAL_NAME")) {
            if (row.WELL_LEGAL_NAME.value.name == this.$store.state.warningList[i].JH) {
              if (column.property == this.$store.state.warningList[i].data) {
                return 'color : red'
              }
            }
          }
        }
      }

      //隔行换背景色
      let background = "#ffffff";
      if (rowIndex % 2 != 0) {
        background = "#f7fbfe";
      }
      //设置对齐方式，默认：左对齐；数字类型：右对齐
      let textAlign = "left";
      let fieldName = column.property;//字段名字
      //获取值，判断值是否是数字 todo
      let fieldValue = null;//字段值
      if (fieldName != undefined) {

        fieldValue = JSON.parse(JSON.stringify(row[column.property])).value;
        // console.log("fieldValue",fieldValue)
        if(fieldValue!=null && fieldValue != undefined && fieldValue.name != undefined && fieldValue.name != null){
        // if ('name' in fieldValue)
          fieldValue = fieldValue.name;
        }
      }
      //判断字符串是否是数值
      if (!isNaN(parseFloat(fieldValue)) && isFinite(fieldValue)) {
        textAlign = "right";
      }
      this.json.header.forEach(item => {
        if (item.COLUMN_NAME == fieldName) {
          if (item.DATA_TYPE == "NUMBER") {
            textAlign = "right";
          }
        }
      })
      //设置,固定值类型的字段,居中
      let centerField = {
        'JX': 1,//井型（单井基础信息）
      }
      //序号,勾选框，居中
      if (column.label == "序号" || column.type == "selection" || centerField[fieldName] == 1) {
        textAlign = "center";
      }



      let style = {
        background: background,
        height: "36px",
        fontSize: "14px",
        fontcolor: "#333333",
        // fontWeight: "bold",
        border: "1px solid #e5e5e5",
        textAlign: textAlign
      }
      return style;
    },
//表格内容是否可编辑初始化
    useEdit() {
      this.json.data.forEach((item, index) => {
        item.index = this.dataTotal + index + 1;
        for (let i in item) {
          this.json.data[index][i] = {
            value: this.json.data[index][i],
            edit: false
          }
        }
      });
    },
//获取表头,正式上线可删除
    getTableHeader() {
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/pagelist")
          .then(res => {
            // this.tableHead=JSON.parse(res.data.data);
            res.data.data.forEach(item => {
              //item.JPG.link=require(item.JPG.link)
              this.tableHead.push(item)
            });
            console.log(this.tableHead)
            if (this.tableHead.length != 0) {
              this.getTableData();
            }
          }).catch(err => {
        console.log(err)
      })
    },
    //获取表格数据,正式上线可删除
    getTableData() {
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/list")
          .then(res => {
            // this.tableDatas=res.data.data;
            res.data.data.forEach(item => {
              this.tableDatas.push(item)
            });
            console.log(this.tableDatas)
            this.useEdit();
          }).catch(err => {
        console.log(err)
      })
    },
//合并单元格
    objectSpanMethod(row, column, rowIndex, columnIndex) {
      console.log(row, column, rowIndex, columnIndex)
      if (columnIndex == 0) {
        if (rowIndex % 2 == 0) {
          return {
            rowSpan: 2,
            colSpan: 1,
          }
        } else {
          return {
            rowSpan: 2,
            colSpan: 1,
          }
        }
      }
    },
//清除冻结
    RemoveFixed() {
      this.json.header.forEach(item => {
        item.isFixed = null;

      })
      this.xxoo = -1;
    },
//表格删除
    deleteRow(scope) {
      ElMessageBox.confirm(
          '你真的要删除这一行数据吗',
          'warning', {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          }
      ).then(() => {
        this.json.data.forEach((item, index) => {
          if (item.id == scope.row.id) {
            this.json.data.splice(index, 1)
          }
        })
        ElMessage({type: "success", message: "删除成功"})
      }).catch(() => {
        console.log(scope);
        ElMessage({type: "info", message: "删除已取消"})
      })
    },
//行内容编辑
    ChangeRow(scope) {
      this.changes = scope.row;
      console.log(scope.row);
      this.dialogFormVisible = true;
    },
//内容编辑成功
    changeRowOk() {
      var _this = this;
      this.tableData.forEach((item, index) => {
        if (_this.changes.num == item.num) {
          _this.tableData[index] = _this.changes
        }
      });
      this.dialogFormVisible = false;
      ElMessage({type: "success", message: "修改成功"})
    },
    // see(row, column, cell, event){
    //   console.log(row, column, cell, event)
    // },
    //双击表格修改内容
    tableClick(row, column) {
      let edit;
      // console.log(column)
      console.log(column.label);
      for (var i = 0; i < this.json.header.length; i++) {
        if (this.json.header[i].label == column.label) {
          // console.log(this.json.header[i])
          edit = this.json.header[i].edit;
        }
      }
      if (!edit){
        return
      }
      let pKey = this.gridCfg.data.template.pKey;
      for (let i=0;i<pKey.length;i++){
        if (column.property==pKey[i]){
          ElMessage.info("不能修改主键信息")
          return;
        }
      }

      //获取展示对应值
      let value = row[column.property].value;
      if (typeof value == "object")
        row[column.property].value = value.name;
      else if (typeof value == "string")
        row[column.property].value = value;

      row[column.property].edit = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      }, 50)
    },
    //表格修改完成
    changeData(scope) {
      // console.log(scope)
      // console.log(this.json.data)
      // console.log(this.gridCfg.data.template.pKey)
      // console.log( scope.row[scope.column.property].value)
      // console.log(this.tableDataCopy)
      scope.row[scope.column.property].edit = false;
      //将当前值保存在‘editValue’
      this.tableDataCopy[scope.$index][scope.column.property].editValue = scope.row[scope.column.property].value;
      this.getEditTableDataList();
    },
    //获取处理报表修改内容
    getEditTableDataList(){
      this.editTableList=[];//清空数据
      let pKey = this.gridCfg.data.template.pKey;
      //通过比较备份报表数据，找出修改过的数据
      this.tableDataCopy.forEach(item=>{
        let editTableOne={};
        let orgData = {};//修改前数据
        let editData = {};//修改后数据
        for (let key in item) {
          //‘editValue’与value不同，则记录修改值
          if ('editValue' in item[key] && item[key].value.name!=item[key].editValue) {
            orgData[key] = item[key].value.name;
            editData[key] = item[key].editValue;
          }
        }
        //记录修改值这一行数据的主键信息
        if (JSON.stringify(orgData) != "{}") {
          for (let i = 0; i < pKey.length; i++) {
            orgData[pKey[i]] = item[pKey[i]].value.name;
            editData[pKey[i]] = item[pKey[i]].value.name;
          }
          editTableOne.orgData=orgData;
          editTableOne.editData=editData;
          this.editTableList.push(editTableOne);
        }
      })
      this.$parent.$parent.$parent.$data.editTableList=this.editTableList;
      console.log("报表修改数据:",this.editTableList);
    },

//表格的冻结列
    tableFixed(num) {
      console.log(num);
      console.log(this.json.header)
      this.json.header.forEach(item => {
        item.isFixed = null;
      });
      for (var i = 0; i < num; i++) {
        this.json.header[i].isFixed = "left";
      }
    },
    //当选择列状态改变时
    handleSelectionChange(val) {
      this.curSelRowArray = val;
      this.selectColumnStatusChanged(this.curSelRowArray);
    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          let obj = JSON.parse(str);
          console.log(obj)
          return true;
        } catch (e) {
          return false;
        }
      }
      return true;
    },
//判断当前行数据是否可选中
    checkSelectable(row) {
      let result = false;
      // console.log(row)
      // console.log(this.checkSelectablefield)
      // console.log(row[this.checkSelectablefield])
      //判断页面类型，考核：PUBLISHER；审核及其他
      if (this.checkSelectablefield == "PUBLISHER") {
        let rowVal = row[this.checkSelectablefield].value["name"];
        if (rowVal == null)
          result = true;
      }
      else if (this.checkSelectablefield == "upload") {
        result = true;
      }
      else {
        let num =0;
        for(let i in row){
          if (i == this.checkSelectablefield){
            num ++;
          }
        }
        if (num == 0){
          return false
        }

        let rowVal = row[this.checkSelectablefield].value;
        if(this.checkSelectablefield == 'isVerifyable')
        {
          result = rowVal>0;
        }
        else{
          if (this.isJSON(rowVal)) {
            rowVal = rowVal["name"];
          }
          if(this.checkSelectablefield == 'sh_stat')
          {
            if (rowVal == "待送审" || rowVal == "一审驳回" || rowVal == "二审驳回" || rowVal == "终审驳回") result = true;
          }
          else {
            if (rowVal == "待送审" || rowVal == "待初审" || rowVal == "待终审"
                || rowVal == "待一审" || rowVal == "待二审" || rowVal == "待终审"
                || rowVal == "待送二审" || rowVal == "待送终审"
            ) result = true;
          }
        }
      }
      return result;
    },
    openMenu(row, column, cell, event) {
      console.log("888tableJson",this.json,this.needShowProblemMenu,row,this.problemBankInfo);
      //TODO-这个功能应该移值到外面响应，先放在这里赶进度
      console.log(this.needShowProblemMenu && this.problemBankInfo)
      if(this.needShowProblemMenu && this.problemBankInfo) {
        let x = event.clientX;
        let y = event.clientY;
        this.top = y;
        this.left = x;
        this.visible = true;

        let _this = this;
        // console.log("problemBankInfo:",_this.problemBankInfo);
        let bankKey = _this.problemBankInfo.bankkey;
        let bankMasterField = _this.problemBankInfo.bankmasterfield;
        let bankMasterKeyValField = _this.problemBankInfo.bankmasterkeyvalfield;
        let moduleKeyFields = _this.problemBankInfo.module_keyfields;
        let moduleKeyNames = _this.problemBankInfo.module_keynames;
        _this.curProblemData = {};
        if (Object.prototype.hasOwnProperty.call(row, bankKey)) {
          _this.curProblemData[bankKey] = row[bankKey].value.name;
        }
        if (Object.prototype.hasOwnProperty.call(row, bankMasterField)) {
          _this.curProblemData[bankMasterField] = row[bankMasterField].value.name;
        }
        if (Object.prototype.hasOwnProperty.call(row, bankMasterKeyValField)) {
          _this.curProblemData[bankMasterKeyValField] = row[bankMasterKeyValField].value.name;
        }
        let moduleKeyFieldAry = moduleKeyFields.split(",");
        let moduleKeyNameAry = moduleKeyNames.split(",");
        let keyInfoStr = "";
        for (let i = 0; i < moduleKeyFieldAry.length; i++) {
          let keyField = moduleKeyFieldAry[i];
          let keyName = moduleKeyNameAry[i];
          if (Object.prototype.hasOwnProperty.call(row, keyField)) {
            if(keyInfoStr.length>0)
              keyInfoStr+=",";
            _this.curProblemData[keyField] = row[keyField].value.name;
            keyInfoStr += keyName+"："+row[keyField].value.name;
          }
        }

        // _this.curProblemData["keyInfo"] = "井名：" + _this.curProblemData.WELL_COMMON_NAME + ", 年月：" + _this.curProblemData.YEAR_MON;
        _this.curProblemData["keyInfo"] = keyInfoStr;
        _this.curProblemData["columnField"] = column.property;
        _this.curProblemData["columnName"] = column.label;
        _this.curProblemData["cellVal"] = cell.innerText;
        _this.curProblemData.moduleid = _this.templateInfo.moduleid;
        _this.curProblemData.modulename = _this.templateInfo.modulename;//这个可能没有

        let userInfoSession = localStorage.getItem("lyqtUserInfo");
        if (userInfoSession == null) userInfoSession = {};
        // console.log("uuuus:", userInfoSession);
        if (userInfoSession.length > 0) {
          let jsonUserInfo = JSON.parse(userInfoSession);
          _this.curProblemData.userid = jsonUserInfo.employeeId;
          _this.curProblemData.username = jsonUserInfo.displayName;
        }
        _this.curProblemData.recordDate = new Date();
          this.screeningData = row;
        // console.log(_this.templateInfo, _this.curProblemData)
      }else{
        this.screeningData = row;
        let x = event.clientX;
        let y = event.clientY;
        this.top = y;
        this.left = x;
        //this.visible = true;
      }
    },
    closeMenu() {
      this.visible = false;
    },
    async doDataProblemRecord() {
      //curProblemData
      let _this = this;
      if (_this.curProblemData.userid.length <= 0) {
        ElMessageBox("错误,当前用户未登录，无法正常正常记录问题信息！");
        return;
      }
      console.log("problemData:", _this.curProblemData);
      await axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/saveProblemRecord",
        method: 'POST',
        data: _this.curProblemData
      }).then(async (res) => {
        if (res.status === 200) {
          let resp = res.data;
          //问题反馈文件处理
          let feedIdStr = "";
          if(resp.length>0) feedIdStr = resp[0].FEEDID;
          console.log("feedfile",resp[0].FEEDID,resp.length,_this.problemFileInfo)
          if( _this.problemFileInfo != null  &&  _this.problemFileInfo != undefined && feedIdStr!=null && feedIdStr != undefined && feedIdStr != "") {
            let fileShard = _this.problemFileInfo;
            let fileReader = new FileReader();
            let fileParam = {};
            let key = hex_md5(fileShard.name + fileShard.size + fileShard.type + fileShard.lastModified);
            let key10 = parseInt(key, 16);
            let key62 = _10to62(key10);
            fileParam.feedRecordID = feedIdStr;
            fileParam.fileKey = key62;
            fileParam.fileSuffix = fileShard.name.substring(fileShard.name.lastIndexOf(".") + 1, fileShard.name.length).toLowerCase();
            fileParam.fileSize = fileShard.size;
            fileParam.fileName = fileShard.name;
            fileReader.onload = async function (e) {
              return new Promise((resolve, reject) => {
                let base64 = e.target.result;
                console.log("base64:", base64, resolve, reject);
                fileParam.fileData = base64;
                // console.log("upload:",param);
                axios.post(process.env.VUE_APP_SERVER + "/fileprocesser/feedFileUpload",fileParam)
                    .then(async (res) => {
                      if (res.status === 200) {
                        let resp = res.data;
                        console.log("上传文件成功：", resp);
                        resolve();
                      }
                    }).catch((err) => {
                  ElMessageBox('Error');
                  console.log(err)
                //   // _this.loading = false;
                //   _this.uploadErrorList.push(param.name);
                  reject();
                })
                ElMessageBox('问题记录成功，可在数据应用反馈信息表中查看！');
                console.log("问题记录成功：", resp);
              }).catch((e)=>{console.log("promiseCatch",e)});
            };
            fileReader.readAsDataURL(fileShard);
          }
          else{
            ElMessageBox('问题记录成功，可在数据应用反馈信息表中查看！');
            console.log("问题记录成功：", resp);
          }
        }
        // _this.loading = false;
      }).catch((err) => {
        ElMessageBox('问题记录失败，请联系管理员！');
        console.log(err)
      })
      this.curProblemData = {};
      this.problemDialogVisible = false;
    },
    setProblemMenuVisible(){
      let _this = this;
      _this.needShowProblemMenu = false;
      let checkUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/checkIsProblemModule?module_id="+this.templateInfo.moduleid;
      axios({
        url: checkUrl,
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          let resp = res.data;
          if (resp.success) {
            console.log("checkIsProblem",resp);
            _this.needShowProblemMenu = true;
            _this.setProblemBankInfo();
          }
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    setProblemBankInfo(){
      let _this = this;
      _this.problemBankInfo = {};
      let checkUrl = process.env.VUE_APP_SERVER + "/dataprovider/businessdata/problemBankInfo?module_id="+this.templateInfo.moduleid;
      axios({
        url: checkUrl,
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          let resp = res.data;
          console.log(resp);
          if (resp.success) {
            _this.problemBankInfo = resp.content[0];
          }
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //拖动表头触发,记录拖动宽度
    dragendHeader(newWidth, oldWidth, column){
      console.log(newWidth, oldWidth)
      this.$parent.$parent.$parent.$data.theHeader.forEach(item=>{
        if (item.COLUMN_NAME==column.property){
          item.WIDTH=Math.round(newWidth);
          console.log(item);
          return
        }
      });
    },
    //报表挂载鼠标滚动监听事件
    addOnscroll(){
      let thisVue=this;
      let ms= 2000;//设置数据加载触发间隔，防止同时多次触发数据查询事件
      let lastClick = Date.now() - ms;
      //初始化 第一个报表的主体挂载鼠标监听事件
      let tableBody=document.getElementsByClassName("el-table__body-wrapper")[0];
      if (tableBody==undefined)
        return
      tableBody.onscroll=function(){
        // console.log("_______________________________________");
        // console.log("scrollTop:",tableBody.scrollTop);
        // console.log("clientHeight:",tableBody.clientHeight);
        // console.log("scrollHeight:",tableBody.scrollHeight);
        // console.log("scrollLeft:",tableBody.scrollLeft);
        // console.log("pageYOffset:",tableBody.clientWidth);
        // console.log("scrollWidth:",tableBody.scrollWidth);
        //触底判断，x轴没有滚动条时退出
        if (tableBody.clientHeight == tableBody.scrollHeight) {
          return
        }
        //触底判断，不是触底的情况退出
        if (Math.ceil(tableBody.scrollTop) + tableBody.clientHeight < tableBody.scrollHeight - 5) {
          return
        }
        tableBody.scrollTop -= 6;
        console.log("触底了");
        if (Date.now() - lastClick >= ms) {
          console.log('加载数据');
          thisVue.$parent.$parent.$parent.infiniteScroll();
          lastClick = Date.now();
        }
      }
      this.addOnscrollHome();
    },
    addOnscrollHome(){
      let thisVue=this;
      let ms= 2000;//设置数据加载触发间隔，防止同时多次触发数据查询事件
      let lastClick = Date.now() - ms;
      //初始化 第一个报表的主体挂载鼠标监听事件
      let tableBody=document.getElementsByClassName("el-table__body-wrapper")[5];
      if(tableBody == undefined)
        return;
      tableBody.onscroll=function(){
        // console.log("_______________________________________");
        // console.log("scrollTop:",tableBody.scrollTop);
        // console.log("clientHeight:",tableBody.clientHeight);
        // console.log("scrollHeight:",tableBody.scrollHeight);
        // console.log("scrollLeft:",tableBody.scrollLeft);
        // console.log("pageYOffset:",tableBody.clientWidth);
        // console.log("scrollWidth:",tableBody.scrollWidth);
        //触底判断，x轴没有滚动条时退出
        if (tableBody.clientHeight == tableBody.scrollHeight) {
          return
        }
        //触底判断，不是触底的情况退出
        if (Math.ceil(tableBody.scrollTop) + tableBody.clientHeight < tableBody.scrollHeight - 5) {
          return
        }
        tableBody.scrollTop -= 6;
        console.log("触底了");
        if (Date.now() - lastClick >= ms) {
          console.log('加载数据');
          thisVue.$parent.$parent.$parent.infiniteScroll();
          lastClick = Date.now();
        }
      }
    },
  },
  props: {
    //表格是否支持选中
    selectable: {
      default: false
    },
    checkSelectablefield:{
      default:"status"
    },
    gridCfg:{
      default: {}
    },
    templateInfo: {
      default: {}
    },
    selectColumnStatusChanged: {
      type: Function,
      default: null
    },
    showRouteIn:{
      default: false
    },
    showRouteOutEvent: {
      type: Function,
      default: null
    },
  },
  setup () {
    let fileDialogVisible = ref(true)
    let imgDialogVisible = ref(false)
    let assessDialogVisible = ref(false)//考核指标弹窗打开标识
    let uploadListDialogVisible = ref(false)//数据上传详情弹窗打开标识

    const closeFileDialog = () => {
      fileDialogVisible.value = false
    }
    const closeImgDialog = () => {
      imgDialogVisible.value = false
    }
    const closeAsseaaDialog = () => {
      assessDialogVisible.value = false
    }
    const closeUploadListDialog = () => {
      uploadListDialogVisible.value = false
    }

    return {
      fileDialogVisible,
      imgDialogVisible,
      assessDialogVisible,
      uploadListDialogVisible,
      closeFileDialog,
      closeImgDialog,
      closeAsseaaDialog,
      closeUploadListDialog
    }
  },
  watch: {
    // showRouteIn:{
    //   handler() {
    //     console.log("routin",this.showRouteIn)
    //   }
    // },
    templateInfo: {
      handler() {
        {
          this.loading=true;
          //TODO-这个功能应该移值到外面响应，先放在这里赶进度
          this.setProblemMenuVisible();
          // this.$nextTick(() => {
          //   this.$refs.maintb.doLayout();
          // });
        }
        console.log("watch结束")
      },
      deep: true,
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    json :{
      handler(){
        this.$nextTick(() => {
          this.$refs.maintb.doLayout();
        });
      },
      deep:true,
      immediate:true
    },
  }
}

</script>

<style scoped>

.color {
  color: #409EFF;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background-color: rgb(3, 125, 243);;
  color: white;
}

/*/deep/.el-image-viewer__mask {*/
/*  position: absolute;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  top: 0;*/
/*  left: 0;*/
/*  opacity: 1;*/
/*  background: #fff;*/
/*}*/
/deep/.el-image-viewer__img {
  background: #fff;
}
/deep/.el-table_7_column_13 {
  padding-top: 0px;
  padding-bottom: 0px;
  border-bottom-width: 0px;
  /*background-image: url("../assets/123.jpeg");*/
  /*background-size: 100% 100%;*/
}
/*/deep/.el-table__row {*/
/*  height: 60px;*/
/*}old head backcolor:545c64 color fff*/
/deep/.el-table td{
  text-align: center;
}
/*/deep/.el-table th {*/
/*  overflow: hidden;*/
/*  -webkit-user-select: none;*/
/*  -moz-user-select: none;*/
/*  user-select: none;*/
/*  background: #e5f9f9;*/
/*  color: #545c64;*/
/*  border: 1px solid lightgray;*/
/*  font-size: 14px;*/
/*  text-align: center;*/
/*}*/
/deep/.el-table--border td{
  border: 1px solid #e5e5e5;
}
/*/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {*/
/*  background: #e6f0f9;*/
/*}*/
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  /*background-color: #F5F7FA;*/
  background-color: #fffadf;
  border: 1px solid #fffacf;
}
/deep/.el-divider__text {
  position: absolute;
  background-color: #FFF;
  padding: 0 20px;
  color: #303133;
  font-size: 20px;
  font-weight: bold;
}
/deep/.el-table__header tr,
/deep/.el-table__header th {
  padding: 0;
  height: 35px;
}
/deep/.el-table__body tr,
/deep/.el-table__body td {
  padding: 0;
  height: 25px;
}
</style>
\
<style >
/*报表div 设置左右间隔 样式*/
.bueatyScrollDiv {
  padding-left: 16px;
  /*padding-right: 16px;*/
}
/*!*!*报表内容行 鼠标悬停 样式*!*!*/
/*!*.bueatyScroll .el-table__body tr:hover > td {*!*/
/*!*  background-color: #f5f7fa !important;*!*/
/*!*}*!*/
/*!*报表内容行 鼠标悬停 样式*!*/
/*.bueatyScroll .el-table__body .hover-row > td {*/
/*  background-color: #f5f7fa !important;*/
/*}*/
/*!*!*报表内容行 鼠标点击（获得焦点） 样式*!*!*/
/*!*.bueatyScroll ::v-deep .el-table__body tr:active > td {*!*/
/*!*  background-color: #daebfb !important;*!*/
/*!*}*!*/
/*!*报表内容行 鼠标点击（获得焦点） 样式*!*/
/*.bueatyScroll .el-table__body .current-row > td {*/
/*  background-color: #daebfb !important;*/
/*}*/

/*!*报表表头行 文本内容 样式*!*/
/*.bueatyScroll .el-table__header .cell{*/
/* padding-left: 8px;*/
/* padding-right: 8px;*/
/*}*/
/*!*报表表头行 排序箭头 样式*!*/
/*.bueatyScroll .el-table__header .caret-wrapper {*/
/*  float: right;*/
/*  margin-top: 5px;*/
/*}*/

/*!*报表空数据 设置背景图，并居中  的样式*!*/
/*.bueatyScroll .el-table__empty-block {*/
/*  width: 100% !important;*/
/*  margin: auto;*/
/*  height: 100%!important;*/
/*  min-height: 300px!important;*/
/*  line-height: 300px !important;*/
/*  box-sizing: border-box;*/
/*  background: url('../../public/table_zwsj.png') no-repeat 50% 42%;*/
/*}*/
/*!*报表空数据 文本样式*!*/
/*.bueatyScroll .el-table__empty-text {*/
/*  font-size: 14px;*/
/*  color: #666;*/
/*}*/
</style>